import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={672.744}
      height={461.384}
      viewBox="0 0 672.744 461.384"
      {...props}
    >
      <defs>
        <linearGradient
          id="prefix__d"
          x1={-0.758}
          y1={2.587}
          x2={0.242}
          y2={2.587}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#dae3fe" />
          <stop offset={1} stopColor="#e9effd" />
        </linearGradient>
        <linearGradient
          id="prefix__e"
          x1={0.481}
          y1={-0.36}
          x2={0.531}
          y2={1.741}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#fe7062" />
          <stop offset={1} stopColor="#ff928e" />
        </linearGradient>
        <linearGradient
          id="prefix__f"
          x1={0.48}
          y1={-0.302}
          x2={0.529}
          y2={1.664}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#e1473d" />
          <stop offset={1} stopColor="#e9605a" />
        </linearGradient>
        <linearGradient
          id="prefix__b"
          x1={-1.539}
          y1={-1.309}
          x2={1.472}
          y2={1.358}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#09005d" />
          <stop offset={1} stopColor="#1a0f91" />
        </linearGradient>
        <linearGradient
          id="prefix__a"
          x1={0.877}
          y1={0.993}
          x2={0.374}
          y2={0.079}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#ff928e" />
          <stop offset={1} stopColor="#feb3b1" />
        </linearGradient>
        <linearGradient
          id="prefix__c"
          x1={82.162}
          y1={-21.204}
          x2={82.362}
          y2={-19.418}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#4042e2" />
          <stop offset={1} stopColor="#4f52ff" />
        </linearGradient>
        <linearGradient
          id="prefix__g"
          x1={1.392}
          y1={-1.238}
          x2={0.832}
          y2={-0.076}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__h"
          x1={-4.81}
          y1={0.284}
          x2={-4.292}
          y2={2.674}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__i"
          x1={64.098}
          y1={-57.165}
          x2={64.254}
          y2={-52.452}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__j"
          x1={33.863}
          y1={0.171}
          x2={34.484}
          y2={1.621}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__k"
          x1={0.063}
          y1={-0.535}
          x2={1.163}
          y2={2.302}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__l"
          x1={0.93}
          y1={8.328}
          x2={2.019}
          y2={8.225}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__m"
          x1={-4.962}
          y1={-4.015}
          x2={4.853}
          y2={3.922}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__n"
          x1={1.046}
          y1={25.807}
          x2={5.009}
          y2={25.476}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__o"
          x1={1.555}
          y1={0.874}
          x2={0.332}
          y2={0.384}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__p"
          x1={430.601}
          y1={0.954}
          x2={432.762}
          y2={-0.303}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__q"
          x1={49.715}
          y1={0.128}
          x2={49.962}
          y2={-20.766}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__r"
          x1={39.473}
          y1={4.039}
          x2={39.669}
          y2={-0.315}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__s"
          x1={36.249}
          y1={37.895}
          x2={35.51}
          y2={40.332}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__t"
          x1={0.121}
          y1={0.927}
          x2={0.749}
          y2={0.247}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__u"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__v"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__w"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__x"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__z"
          x1={0.607}
          y1={-0.627}
          x2={0.367}
          y2={1.875}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__A"
          x1={0.002}
          y1={0.504}
          x2={0.999}
          y2={0.504}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__B"
          x1={-0.012}
          y1={0.504}
          x2={0.987}
          y2={0.504}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__C"
          x1={-0.003}
          y1={0.511}
          x2={0.998}
          y2={0.511}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__D"
          x1={-0.006}
          y1={0.512}
          x2={1.005}
          y2={0.512}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__E"
          x1={-0.001}
          y1={0.503}
          x2={0.999}
          y2={0.503}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__F"
          x1={-0.007}
          y1={0.491}
          x2={1.015}
          y2={0.491}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__G"
          x1={-0.003}
          y1={0.497}
          x2={1.004}
          y2={0.497}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__H"
          x1={-0.003}
          y1={0.503}
          x2={0.998}
          y2={0.503}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__I"
          x1={-0.025}
          y1={0.515}
          x2={1.001}
          y2={0.515}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__J"
          x1={-0.008}
          y1={0.504}
          x2={0.997}
          y2={0.504}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__K"
          x1={-0.004}
          y1={0.502}
          x2={0.996}
          y2={0.502}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__L"
          x1={-0.005}
          y1={0.501}
          x2={1.001}
          y2={0.501}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__M"
          x1={-0.014}
          y1={0.508}
          x2={0.996}
          y2={0.508}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__N"
          x1={-0.025}
          y1={0.519}
          x2={0.993}
          y2={0.519}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__O"
          x1={-0.005}
          y1={0.498}
          x2={1.007}
          y2={0.498}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__P"
          x1={0.011}
          y1={0.496}
          x2={1.011}
          y2={0.496}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__Q"
          x1={-0.012}
          y1={0.501}
          x2={1.016}
          y2={0.501}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__R"
          x1={-0.002}
          y1={0.503}
          x2={1}
          y2={0.503}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__S"
          x1={0}
          y1={0.502}
          x2={1.001}
          y2={0.502}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__T"
          x1={0.011}
          y1={0.501}
          x2={1}
          y2={0.501}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__U"
          x1={-0.036}
          y1={0.502}
          x2={1.001}
          y2={0.502}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__V"
          x1={0}
          y1={0.507}
          x2={1.004}
          y2={0.507}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__W"
          x1={0.002}
          y1={0.499}
          x2={1.003}
          y2={0.499}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__X"
          x1={0.01}
          y1={0.503}
          x2={1.013}
          y2={0.503}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__Y"
          x1={-0.008}
          y1={0.497}
          x2={1.001}
          y2={0.497}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__Z"
          x1={0}
          y1={0.498}
          x2={1}
          y2={0.498}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aa"
          x1={-0.004}
          y1={0.498}
          x2={0.996}
          y2={0.498}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__ab"
          x1={-0.001}
          y1={0.499}
          x2={0.999}
          y2={0.499}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__ac"
          x1={-0.004}
          y1={0.499}
          x2={0.995}
          y2={0.499}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__ad"
          x1={-0.004}
          y1={0.5}
          x2={1.006}
          y2={0.5}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__ae"
          x1={0.005}
          y1={0.5}
          x2={0.998}
          y2={0.5}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__af"
          x1={-0.003}
          y1={0.497}
          x2={0.998}
          y2={0.497}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__ag"
          x1={0.005}
          y1={0.501}
          x2={0.998}
          y2={0.501}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__ah"
          x1={0.018}
          y1={0.502}
          x2={0.983}
          y2={0.502}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__ai"
          x1={-0.009}
          y1={0.496}
          x2={0.999}
          y2={0.496}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aj"
          x1={-0.003}
          y1={0.493}
          x2={0.986}
          y2={0.493}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__ak"
          x1={0.005}
          y1={0.499}
          x2={0.995}
          y2={0.499}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__al"
          x1={-0.001}
          y1={0.495}
          x2={0.995}
          y2={0.495}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__am"
          x1={0.012}
          y1={0.51}
          x2={1.011}
          y2={0.51}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__an"
          x1={-0.001}
          y1={0.503}
          x2={1.009}
          y2={0.503}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__ao"
          x1={-0.001}
          y1={0.504}
          x2={1.009}
          y2={0.504}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__ap"
          x1={0.001}
          y1={0.495}
          x2={0.992}
          y2={0.495}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aq"
          x1={0}
          y1={0.497}
          x2={0.994}
          y2={0.497}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__ar"
          x1={0}
          y1={0.504}
          x2={1.009}
          y2={0.504}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__as"
          x1={0.01}
          y1={0.508}
          x2={1.006}
          y2={0.508}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__at"
          x1={0}
          y1={0.5}
          x2={1.001}
          y2={0.5}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__au"
          x1={-0.01}
          y1={0.495}
          x2={1.001}
          y2={0.495}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__av"
          x1={0}
          y1={0.501}
          x2={1}
          y2={0.501}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aw"
          x1={0}
          y1={0.501}
          x2={1.001}
          y2={0.501}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__ax"
          x1={0.029}
          y1={0.498}
          x2={0.967}
          y2={0.498}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__ay"
          x1={-0.02}
          y1={0.478}
          x2={0.976}
          y2={0.478}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__az"
          x1={0}
          y1={0.503}
          x2={1.008}
          y2={0.503}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aA"
          x1={0}
          y1={0.501}
          x2={1.003}
          y2={0.501}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aB"
          x1={0}
          y1={0.502}
          x2={1.003}
          y2={0.502}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aC"
          x1={0.001}
          y1={0.499}
          x2={1.002}
          y2={0.499}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aD"
          x1={-0.001}
          y1={0.502}
          x2={1.003}
          y2={0.502}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aE"
          x1={0}
          y1={0.502}
          x2={1}
          y2={0.502}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aF"
          x1={0.001}
          y1={0.504}
          x2={1.001}
          y2={0.504}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aG"
          x1={0.029}
          y1={0.501}
          x2={0.975}
          y2={0.501}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aH"
          x1={0.038}
          y1={0.503}
          x2={0.97}
          y2={0.503}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aI"
          x1={0}
          y1={0.497}
          x2={0.994}
          y2={0.497}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aJ"
          x1={-0.009}
          y1={0.502}
          x2={1.015}
          y2={0.502}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aK"
          x1={0}
          y1={0.503}
          x2={1.006}
          y2={0.503}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aL"
          x1={0.001}
          y1={0.5}
          x2={1.004}
          y2={0.5}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aM"
          x1={0.002}
          y1={0.504}
          x2={1.013}
          y2={0.504}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aN"
          x1={0}
          y1={0.501}
          x2={1.005}
          y2={0.501}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aO"
          x1={-0.001}
          y1={0.506}
          x2={1.018}
          y2={0.506}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aP"
          x1={0}
          y1={0.497}
          x2={0.994}
          y2={0.497}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aQ"
          x1={-0.011}
          y1={0.498}
          x2={1.005}
          y2={0.498}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aR"
          x1={0}
          y1={0.503}
          x2={1.014}
          y2={0.503}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aS"
          x1={0}
          y1={0.501}
          x2={1.005}
          y2={0.501}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aT"
          x1={0.001}
          y1={0.499}
          x2={0.992}
          y2={0.499}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aU"
          x1={-0.007}
          y1={0.499}
          x2={1.013}
          y2={0.499}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aV"
          x1={0}
          y1={0.501}
          x2={1.006}
          y2={0.501}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aW"
          x1={0}
          y1={0.501}
          x2={1.005}
          y2={0.501}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aX"
          x1={-0.01}
          y1={0.499}
          x2={1.006}
          y2={0.499}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aY"
          x1={0}
          y1={0.503}
          x2={1.005}
          y2={0.503}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aZ"
          x1={-0.01}
          y1={0.5}
          x2={1.005}
          y2={0.5}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__ba"
          x1={0}
          y1={0.501}
          x2={1.006}
          y2={0.501}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bb"
          x1={0.012}
          y1={0.499}
          x2={1.006}
          y2={0.499}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bc"
          x1={-0.007}
          y1={0.502}
          x2={1.019}
          y2={0.502}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bd"
          x1={0}
          y1={0.499}
          x2={1.003}
          y2={0.499}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__be"
          x1={0.012}
          y1={0.492}
          x2={1.03}
          y2={0.492}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bf"
          x1={-0.001}
          y1={0.493}
          x2={0.998}
          y2={0.493}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bg"
          x1={0.001}
          y1={0.492}
          x2={1.018}
          y2={0.492}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bh"
          x1={0.002}
          y1={0.499}
          x2={1.005}
          y2={0.499}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bi"
          x1={-0.001}
          y1={0.497}
          x2={1.004}
          y2={0.497}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bj"
          x1={0}
          y1={0.496}
          x2={1.003}
          y2={0.496}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bk"
          x1={0}
          y1={0.491}
          x2={1.013}
          y2={0.491}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bl"
          x1={0.019}
          y1={0.486}
          x2={1.013}
          y2={0.486}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bm"
          x1={0.01}
          y1={0.489}
          x2={1.011}
          y2={0.489}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bn"
          x1={-0.001}
          y1={0.498}
          x2={0.999}
          y2={0.498}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bo"
          x1={0.019}
          y1={0.499}
          x2={0.988}
          y2={0.499}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bp"
          x1={0}
          y1={0.504}
          x2={0.995}
          y2={0.504}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bq"
          x1={0.005}
          y1={0.502}
          x2={1}
          y2={0.502}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__br"
          x1={0.001}
          y1={0.5}
          x2={1.007}
          y2={0.5}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bs"
          x1={0.015}
          y1={0.493}
          x2={0.996}
          y2={0.493}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bt"
          x1={0}
          y1={0.505}
          x2={0.998}
          y2={0.505}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bu"
          x1={-0.001}
          y1={0.504}
          x2={1.002}
          y2={0.504}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bv"
          x1={-0.002}
          y1={0.487}
          x2={0.997}
          y2={0.487}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bw"
          x1={-0.002}
          y1={0.494}
          x2={1}
          y2={0.494}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bx"
          x1={-0.004}
          y1={0.494}
          x2={0.995}
          y2={0.494}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__by"
          x1={-0.003}
          y1={0.496}
          x2={0.987}
          y2={0.496}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bz"
          x1={-0.008}
          y1={0.505}
          x2={1.01}
          y2={0.505}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bA"
          x1={0.005}
          y1={0.513}
          x2={1.007}
          y2={0.513}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bB"
          x1={-0.005}
          y1={0.503}
          x2={1.008}
          y2={0.503}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bC"
          x1={-0.004}
          y1={0.504}
          x2={1.008}
          y2={0.504}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bD"
          x1={-0.003}
          y1={0.498}
          x2={0.998}
          y2={0.498}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bE"
          x1={-0.002}
          y1={0.504}
          x2={1.01}
          y2={0.504}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bF"
          x1={0.004}
          y1={0.498}
          x2={1}
          y2={0.498}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bG"
          x1={-0.012}
          y1={0.491}
          x2={0.999}
          y2={0.491}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bH"
          x1={0}
          y1={0.5}
          x2={1.012}
          y2={0.5}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bI"
          x1={-0.007}
          y1={0.505}
          x2={1.025}
          y2={0.505}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bJ"
          x1={0.004}
          y1={0.501}
          x2={1}
          y2={0.501}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bK"
          x1={-0.018}
          y1={0.495}
          x2={1.005}
          y2={0.495}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bL"
          x1={-0.005}
          y1={0.501}
          x2={0.999}
          y2={0.501}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bM"
          x1={0.002}
          y1={0.5}
          x2={0.999}
          y2={0.5}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bN"
          x1={-0.008}
          y1={0.501}
          x2={1.011}
          y2={0.501}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bO"
          x1={-0.007}
          y1={0.497}
          x2={1}
          y2={0.497}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bP"
          x1={-0.003}
          y1={0.49}
          x2={1.005}
          y2={0.49}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bQ"
          x1={-0.013}
          y1={0.506}
          x2={1.011}
          y2={0.506}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bR"
          x1={-0.004}
          y1={0.503}
          x2={1.001}
          y2={0.503}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bS"
          x1={-0.002}
          y1={0.496}
          x2={1.005}
          y2={0.496}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bT"
          x1={0.001}
          y1={0.493}
          x2={0.998}
          y2={0.493}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bU"
          x1={-0.095}
          y1={-1.837}
          x2={1.264}
          y2={3.239}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__bV"
          x1={1.508}
          y1={5.023}
          x2={1.568}
          y2={2.614}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__bW"
          x1={3.644}
          y1={-12.937}
          x2={-0.055}
          y2={11.128}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__bX"
          x1={-52.53}
          y1={-0.843}
          x2={-53.036}
          y2={2.39}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__bY"
          x1={-10.102}
          y1={-5.394}
          x2={-12.62}
          y2={17.7}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__bZ"
          x1={-10.87}
          y1={7.024}
          x2={-10.828}
          y2={4.402}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__ca"
          x1={-45.523}
          y1={-0.223}
          x2={-46.037}
          y2={2.54}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__cb"
          x1={-24.091}
          y1={0.914}
          x2={-24.007}
          y2={-0.171}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__cc"
          x1={0.037}
          y1={-1.161}
          x2={1.077}
          y2={1.848}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__cd"
          x1={0.541}
          y1={-0.073}
          x2={0.484}
          y2={1.325}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__ce"
          x1={-0.839}
          y1={-1.389}
          x2={1.253}
          y2={1.96}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__cf"
          x1={-73.431}
          y1={-0.15}
          x2={-75.185}
          y2={2.993}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__cg"
          x1={-257.976}
          y1={-10.49}
          x2={-258.635}
          y2={-10.136}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__ch"
          x1={0.424}
          y1={0.008}
          x2={0.6}
          y2={1.002}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__ci"
          x1={2.503}
          y1={0.132}
          x2={-0.052}
          y2={0.564}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__cj"
          x1={-104.244}
          y1={-49.09}
          x2={-103.218}
          y2={-49.09}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__ck"
          x1={-488.072}
          y1={-226.05}
          x2={-484.955}
          y2={-228.428}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__cl"
          x1={-0.002}
          y1={0.5}
          x2={0.998}
          y2={0.5}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__cm"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__cn"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__co"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__cp"
          x1={0.497}
          y1={-0.098}
          x2={0.503}
          y2={1.035}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__cq"
          x1={-23.047}
          y1={0.148}
          x2={-25.387}
          y2={2.243}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__cr"
          x1={0}
          y1={0.499}
          x2={1}
          y2={0.499}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__cs"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__ct"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__cu"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__cv"
          x1={18.773}
          y1={-0.484}
          x2={15.938}
          y2={6.012}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__cw"
          x1={70.835}
          y1={0.5}
          x2={71.835}
          y2={0.5}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__cx"
          x1={21.586}
          y1={0.946}
          x2={22.255}
          y2={0.099}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__cy"
          x1={47.213}
          y1={-2.227}
          x2={40.196}
          y2={5.393}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__cz"
          x1={82.035}
          y1={0.5}
          x2={83.035}
          y2={0.5}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__cA"
          x1={15.129}
          y1={0.917}
          x2={15.599}
          y2={0.085}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__cB"
          x1={6.313}
          y1={2.511}
          x2={5.441}
          y2={3.914}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__cC"
          x1={13.861}
          y1={0.5}
          x2={14.861}
          y2={0.5}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__cD"
          x1={238.057}
          y1={1.605}
          x2={240.058}
          y2={4.278}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__cE"
          x1={-5.775}
          y1={4.702}
          x2={4.711}
          y2={-2.174}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__cF"
          x1={15.631}
          y1={5.741}
          x2={13.442}
          y2={9.326}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__cG"
          x1={0.501}
          y1={0.447}
          x2={0.085}
          y2={3.36}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__cH"
          x1={-68.041}
          y1={23.063}
          x2={-69.235}
          y2={20.845}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__cI"
          x1={-31.499}
          y1={-78.774}
          x2={-29.483}
          y2={-81.095}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__cJ"
          x1={-222.624}
          y1={109.992}
          x2={-226.515}
          y2={99.239}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__cK"
          x1={22.867}
          y1={1.186}
          x2={21.29}
          y2={0.256}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__cL"
          x1={-254.735}
          y1={-5.836}
          x2={-255.394}
          y2={-5.482}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__cM"
          x1={1.287}
          y1={0.272}
          x2={0.062}
          y2={0.592}
          xlinkHref="#prefix__a"
        />
        <clipPath id="prefix__y">
          <path
            data-name="Path 10612"
            d="M568.04 256.183l166.233 100.343 156.752-94.413V115.94H581.093z"
            transform="translate(-568.04 -115.94)"
            fill="none"
          />
        </clipPath>
      </defs>
      <g data-name="Asset 1">
        <g transform="translate(0 69.382)" data-name="Layer 2">
          <path
            data-name="Path 10570"
            d="M7.5 205.316c7.8 16.319 20.21 30.072 29.765 45.344 27.615 44.131-1.116 95.782 11.487 143.347 10.981 41.453 56.655 52.563 90.04 54.248 56.256 2.838 112.448-1.419 166.685-19.462 37.636-12.523 75.323-28.916 114.992-29.909 40.554-1.015 78.7 18.241 117.874 27.348 43.02 10 94.479-.859 104.845-57.679 6.427-35.2-10.87-67.619-12.489-102.278-2.144-45.883 36.529-71.063 41.532-113.956 3.155-27.046-8.632-51.208-24.013-70.776-16.23-20.646-38.053-38.888-63.091-40.583-26.17-1.773-49.527 14.482-73.989 22.24C442.405 85 403.414 12.283 340.128 2.151c-28.53-4.576-63.586-2.405-89.494 13.3-24.079 14.601-35.768 47.049-62.786 56.589-28.581 10.071-54.765-10.086-81.939-16.524-28.122-6.662-54.723 5.172-72.314 31.1C16.517 111.772-1.95 144.9.17 178.11a73.2 73.2 0 007.33 27.206z"
            transform="translate(-.003 -69.422)"
            fill="#e9effd"
          />
          <path
            data-name="Path 10571"
            d="M179.618 370.539c-16.769 3.353-38.185-14.931-45.083-34.9-7.1-20.557 5.918-29.166 5.816-57.689-.114-32.393-16.967-37.285-28.116-80.958-2.516-9.853-17.072-66.885.969-77.563 16.667-9.883 63.535 18.479 71.747 54.78 5.855 25.884-12.246 36.751-5.333 66.885 6.065 26.454 22.009 26.835 28.116 52.357 7.438 31.066-6.098 72.685-28.116 77.088z"
            fill="#91b3fa"
          />
          <path
            data-name="Path 10572"
            d="M178.4 378.386c4.52-34.909-4.3-88.766-12.492-127.8-8.872-42.261-18.941-76.732-19.043-77.083l-1.4.417c.1.345 10.156 34.768 19.016 76.975 8.173 38.92 16.976 92.6 12.477 127.307z"
            fill="#7d97f4"
          />
          <path
            data-name="Path 10573"
            d="M160.303 366.64c22-11.46 29.526-50.818 17.021-63.61-8.449-8.644-20.564.447-32.252-8.512-14.925-11.44-3.947-32.993-15.681-60.923-9.985-23.779-33.935-46.28-47.933-41.649-14.649 4.832-22.366 40.686-9.853 62.266 8.134 14.034 20.59 14.724 23.293 27.774 3.134 15.144-12.012 22.051-12.1 36.733-.14 26.362 48.405 63.086 77.505 47.921z"
            fill="#bdd0fb"
          />
          <path
            data-name="Path 10574"
            d="M148.433 376.72a.9.9 0 00.807-1.287c-29.158-60.094-37.714-129.802-37.798-130.502a.9.9 0 10-1.779.213c.081.7 8.671 70.712 37.963 131.071a.9.9 0 00.807.505z"
            fill="#91b3fa"
          />
          <path
            data-name="Path 10575"
            d="M88.603 262.982a.426.426 0 00.339-.69c-9.206-11.817-19.406-29.565-15.735-47.036a30.816 30.816 0 018.4-15.9.429.429 0 10-.561-.648c-.261.228-6.437 5.672-8.7 16.355-2.064 9.82-.981 26.073 15.9 47.738a.432.432 0 00.357.181z"
            fill="#dce5fe"
          />
          <path
            data-name="Path 10576"
            d="M162.287 361.409a.429.429 0 00.354-.186c14.145-20.647 18.971-36.592 14.337-47.417-4.118-9.616-14.517-11.4-14.622-11.422a.429.429 0 10-.138.846c.1 0 10.051 1.74 13.977 10.924 4.5 10.531-.3 26.2-14.259 46.583a.429.429 0 00.111.6.414.414 0 00.24.072z"
            fill="#f0f0f0"
          />
          <path
            data-name="Path 10577"
            d="M496.753 370.539c16.769 3.353 38.185-14.931 45.083-34.9 7.1-20.557-5.918-29.166-5.816-57.689.114-32.393 16.967-37.285 28.116-80.958 2.516-9.853 17.072-66.885-.969-77.563-16.682-9.883-63.535 18.479-71.747 54.78-5.855 25.884 12.246 36.751 5.333 66.885-6.068 26.454-22.009 26.835-28.119 52.357-7.435 31.066 6.101 72.685 28.119 77.088z"
            fill="#91b3fa"
          />
          <path
            data-name="Path 10578"
            d="M497.967 378.386c-4.52-34.909 4.3-88.766 12.492-127.8 8.872-42.261 18.941-76.732 19.04-77.083l1.4.408c-.1.345-10.156 34.768-19.016 76.975-8.17 38.919-16.967 92.6-12.471 127.3z"
            fill="#7d97f4"
          />
          <path
            data-name="Path 10579"
            d="M516.066 366.64c-22-11.46-29.529-50.818-17.024-63.61 8.449-8.644 20.567.447 32.255-8.512 14.925-11.439 3.944-32.993 15.677-60.923 9.988-23.779 33.938-46.28 47.932-41.661 14.652 4.832 22.369 40.686 9.856 62.266-8.137 14.034-20.591 14.724-23.293 27.774-3.137 15.144 12 22.051 12.093 36.733.151 26.374-48.397 63.097-77.496 47.933z"
            fill="#bdd0fb"
          />
          <path
            data-name="Path 10580"
            d="M527.938 376.72a.915.915 0 01-.393-.09.9.9 0 01-.414-1.2c29.163-60.095 37.714-129.809 37.792-130.5a.9.9 0 111.779.213c-.084.7-8.671 70.712-37.963 131.071a.9.9 0 01-.801.506z"
            fill="#91b3fa"
          />
          <path
            data-name="Path 10581"
            d="M587.769 262.982a.426.426 0 01-.339-.69c9.2-11.817 19.409-29.568 15.735-47.036a30.841 30.841 0 00-8.4-15.9.429.429 0 11.561-.648c.261.228 6.437 5.672 8.7 16.355 2.064 9.82.981 26.073-15.9 47.737a.426.426 0 01-.357.182z"
            fill="#dce5fe"
          />
          <path
            data-name="Path 10582"
            d="M514.086 361.409a.425.425 0 01-.354-.186c-14.148-20.647-18.971-36.592-14.34-47.417 4.121-9.616 14.52-11.4 14.625-11.422a.429.429 0 01.135.846c-.1 0-10.048 1.74-13.977 10.924-4.5 10.531.3 26.2 14.262 46.583a.429.429 0 01-.111.6.42.42 0 01-.24.072z"
            fill="#f0f0f0"
          />
          <path
            data-name="Path 10583"
            d="M517.93 553.24v183.989c0 13.539 11.892 24.514 26.562 24.514h308.95c14.67 0 26.559-10.975 26.559-24.514V553.24z"
            transform="translate(-362.586 -387.316)"
            fill="url(#prefix__e)"
          />
          <path
            data-name="Path 10584"
            d="M788.8 251.595l-78.532-47.516a23.117 23.117 0 00-24.352 0l-78.529 47.5-90.707 54.871 90.706 54.744 90.706 54.732 90.708-54.792 90.7-54.672z"
            transform="translate(-361.711 -140.454)"
            fill="#e1473d"
          />
          <g data-name="Group 499" fill="#fff">
            <path
              data-name="Path 10585"
              d="M162.438 366.474a.624.624 0 01-.42-.159.633.633 0 01-.054-.9l113.132-127.283a.634.634 0 01.948.843L162.915 366.261a.635.635 0 01-.477.213z"
            />
            <path
              data-name="Path 10586"
              d="M510.322 366.475a.636.636 0 01-.474-.213L396.716 238.979a.636.636 0 11.951-.843l113.12 127.283a.633.633 0 01-.477 1.056z"
            />
          </g>
          <path
            data-name="Path 10587"
            d="M1513.823 912.622s-3.722-4.469 1.341-7.228 13.038.267 14.046 6.131 6.047 2.381 8.245 1.1 8.335-3.023 9.9 3.665c.618 2.648-.165 6.032.987 8.5 1.581 3.392 6.733 2.516 9.547 3.812 3.656 1.689 5.567 4.952 3.665 8.758-2.933 5.861-8.7 9.6-5.588 14.7s-9.436 16.55-13.74 5.924-10.993-8.827-16.4-9.5-8.152-5.345-6.686-10.108a8.738 8.738 0 00-2.475-9.616c-2.014-2.021-8.796-10.734-2.842-16.138z"
            transform="translate(-1058.101 -633.125)"
            fill="url(#prefix__b)"
          />
          <path
            data-name="Path 10588"
            d="M1470.68 1122a23.871 23.871 0 00-8.641 3.689 2.285 2.285 0 00-1.008 2.18 96.657 96.657 0 0010.225 32.093 3.442 3.442 0 01.333 2.37l-1.29 6-2.4 2.243h6.164l4.1-11.1-1.755-.555a3.32 3.32 0 01-2.318-3.11l-.186-11.917a13.537 13.537 0 00-3.254-8.968l9.844-.48z"
            transform="translate(-1022.807 -785.486)"
            fill="url(#prefix__a)"
          />
          <path
            data-name="Path 10589"
            d="M1475.922 1257.755c-.561.735 6.041 1.7 9.376.1 0 0 4.622-8.047 4.622-12.189 0 0-.366-.843-3.08-.651 0 0-1.554 9.526-3.191 10.591s-4.586.108-4.586.108a9.852 9.852 0 00-3.141 2.041z"
            transform="translate(-1033.22 -871.583)"
            fill="url(#prefix__c)"
          />
          <path
            data-name="Path 10590"
            d="M1425.882 1138.672c-.054-.093-10.6-1.269-10.6-1.269a24.341 24.341 0 01-.735 7.618c-1.08 4.412-16.56 23.536-16.56 23.536l1.623 5.147a26.186 26.186 0 01-14.814.9l10.06-6.038s9.415-32.093 15.183-37.81l10.57-3.656z"
            transform="translate(-969.452 -789.056)"
            fill="url(#prefix__g)"
          />
          <path
            data-name="Path 10591"
            d="M1508.684 1103.43s6.074 9.037 6.575 13.158-1.665 5.8-8.038 6.074-23.395.273-23.395.273l-14.526-12.414s10.585-3.776 13.338-4.844 26.046-2.247 26.046-2.247z"
            transform="translate(-1028.607 -772.486)"
            fill="url(#prefix__h)"
          />
          <path
            data-name="Path 10592"
            d="M1392.386 1276.7s1.746 1.692.567 3.575c0 0-13.845 2.453-17.6 1.341 0 0 .78-1.782 5.012-3.809l-.3.24a.507.507 0 00.333.9c2.774-.147 8.548-.657 11.988-2.247z"
            transform="translate(-962.836 -893.786)"
            fill="url(#prefix__i)"
          />
          <path
            data-name="Path 10593"
            d="M1516.529 1022.992a138.823 138.823 0 01-10.558-11.2 9.475 9.475 0 01-1.6-8.521c1.59-5.357 4.415-10.9 4.673-11.766.4-1.323 8.326-1.269 8.326-1.269s15.6 10.132 21.742 27.294l-6.9 2.145a80.678 80.678 0 00-8.1-11.185s6.968 9.205 7.2 12.972z"
            transform="translate(-1052.883 -693.244)"
            fill="url(#prefix__j)"
          />
          <path
            data-name="Path 10594"
            d="M1517.67 967.311c.084.273 2.154 7.139 2.316 7.279s4.541.378 6.6-1.029l-3.5-7.321z"
            transform="translate(-1062.47 -676.444)"
            fill="url(#prefix__k)"
          />
          <path
            data-name="Path 10595"
            d="M1511.535 921.218s-3.734 1.578-6.275 6.976-.645 7.894 1.74 8.239a11.123 11.123 0 009.721-3.2c3.773-3.5-.321-13.887-5.186-12.015z"
            transform="translate(-1052.936 -644.768)"
            fill="url(#prefix__l)"
          />
          <path
            data-name="Path 10596"
            d="M1522.4 919.176s2.822-7.9-4.184-8l-1.65 1.152s-2.57-4.382 1.65-6.473a8.962 8.962 0 0112.3 5.456c1.8 5.684.744 9.355-2.244 12.073s-4.217-.363-4.217-.363 1.626-2.543.966-3.9-2.192.282-2.192.282z"
            transform="translate(-1061.157 -633.591)"
            fill="url(#prefix__m)"
          />
          <path
            data-name="Path 10597"
            d="M1535.35 949.8s1.425-4.07 3.326-2.448-1.545 3.758-2.895 4.451z"
            transform="translate(-1074.847 -662.951)"
            fill="url(#prefix__n)"
          />
          <path
            data-name="Path 10598"
            d="M1497.78 1087.193l5.2-5.009 7.2 3.038s7.159 1.107 11.253 0l4.1-1.11 9.256-2.882 1.454 4.109a2.474 2.474 0 01-.9 2.844 16.341 16.341 0 01-2.339 1.455c-1.23.522-30.053-.378-30.053-.378z"
            transform="translate(-1048.546 -756.944)"
            fill="url(#prefix__o)"
          />
          <g data-name="Group 500">
            <path
              data-name="Path 10599"
              d="M486.993 286.065l-.246-.027c.213-1.968-.114-3.275-1-4-1.755-1.446-5.4-.315-8.608.681a20.618 20.618 0 01-4.241 1.041 2.457 2.457 0 01-1.962-.651 3.374 3.374 0 01-.81-2.339h.249a3.219 3.219 0 00.735 2.157 2.241 2.241 0 001.773.576 20.449 20.449 0 004.181-1.029c3.272-1.017 6.982-2.168 8.839-.639.959.793 1.313 2.19 1.09 4.23z"
              fill="#bdd0fb"
            />
          </g>
          <g data-name="Group 501">
            <path
              data-name="Path 10600"
              d="M494.645 315.666c-.579-2.378.984-4.388 2.792-6.716a20.9 20.9 0 003.569-5.855 3.341 3.341 0 00-.243-2.966c-1.683-2.75-7.277-3.551-7.33-3.557l.033-.246c.234.033 5.762.825 7.5 3.674a3.567 3.567 0 01.267 3.176 21.336 21.336 0 01-3.6 5.924c-1.77 2.276-3.3 4.244-2.747 6.509z"
              fill="#bdd0fb"
            />
          </g>
          <path
            data-name="Rectangle 1500"
            transform="translate(466.718 356.25)"
            fill="url(#prefix__p)"
            d="M0 0h2.738v29.61H0z"
          />
          <path
            data-name="Path 10601"
            d="M1544.64 1284.262h-23.98a1.782 1.782 0 011.781-1.782h20.417a1.782 1.782 0 011.782 1.782z"
            transform="translate(-1064.563 -897.832)"
            fill="url(#prefix__q)"
          />
          <rect
            data-name="Rectangle 1501"
            width={30.152}
            height={8.551}
            rx={4.276}
            transform="translate(453.485 349.615)"
            fill="url(#prefix__r)"
          />
          <path
            data-name="Path 10602"
            d="M1489.671 1102.622h-.069l-30.152-.033a1.35 1.35 0 010-2.7l30.152.033a1.35 1.35 0 01.066 2.7z"
            transform="translate(-1020.767 -770.007)"
            fill="url(#prefix__s)"
          />
          <path
            data-name="Path 10603"
            d="M1367.638 1017.71h25.125a4.8 4.8 0 014.328 2.744l11.61 24.616h-31.193a2.909 2.909 0 01-2.7-1.839l-9-22.777a2.006 2.006 0 011.827-2.744z"
            transform="translate(-956.06 -712.476)"
            fill="url(#prefix__t)"
          />
          <path
            data-name="Path 10604"
            d="M1404.02 1109.419a1.113 1.113 0 00-.264-.963 1.27 1.27 0 00-.96-.426h-125.82a1.46 1.46 0 00-1.2.621 1.272 1.272 0 00-.093 1.284l1.365 2.768a1.92 1.92 0 001.734 1.038h123.159a1.425 1.425 0 001.422-1.1z"
            transform="translate(-892.972 -775.706)"
            fill="url(#prefix__u)"
          />
          <path
            data-name="Path 10605"
            d="M1301.229 1173.157a1.062 1.062 0 01-.435-.093 1.134 1.134 0 01-.579-1.482l23.158-55.08a1.095 1.095 0 011.449-.6 1.143 1.143 0 01.579 1.485l-23.158 55.08a1.1 1.1 0 01-1.014.69z"
            transform="translate(-910.173 -781.155)"
            fill="url(#prefix__v)"
          />
          <path
            data-name="Path 10606"
            d="M1334.154 1173.168a1.1 1.1 0 01-1.017-.684l-23.158-55.08a1.143 1.143 0 01.579-1.485 1.094 1.094 0 011.452.6l23.158 55.08a1.137 1.137 0 01-.579 1.482 1.073 1.073 0 01-.435.087z"
            transform="translate(-917.009 -781.167)"
            fill="url(#prefix__w)"
          />
          <path
            data-name="Path 10607"
            d="M1605.261 1173.157a1.08 1.08 0 01-.435-.093 1.137 1.137 0 01-.579-1.481l23.158-55.08a1.1 1.1 0 011.452-.6 1.143 1.143 0 01.579 1.485l-23.158 55.08a1.1 1.1 0 01-1.017.689z"
            transform="translate(-1123.016 -781.155)"
            fill="url(#prefix__w)"
          />
          <path
            data-name="Path 10608"
            d="M1638.191 1173.169a1.1 1.1 0 01-1.014-.684l-23.158-55.08a1.143 1.143 0 01.579-1.485 1.092 1.092 0 011.449.6l23.158 55.08a1.137 1.137 0 01-.576 1.482 1.086 1.086 0 01-.438.087z"
            transform="translate(-1129.857 -781.167)"
            fill="url(#prefix__x)"
          />
          <g
            data-name="Group 502"
            transform="translate(170.374 34.762)"
            clipPath="url(#prefix__y)"
          >
            <path
              data-name="Path 10609"
              d="M278.627 42.129H25.182a8.381 8.381 0 00-8.17 8.347v205.686h297.967v-177.1z"
              fill="#bdd0fb"
            />
            <path
              data-name="Path 10610"
              d="M314.85 79.06l-33.257.3a2.942 2.942 0 01-2.2-.957 3.088 3.088 0 01-.69-2.348V42.381z"
              fill="#91b3fa"
            />
            <path
              data-name="Path 10611"
              d="M1033.687 441.955a58.634 58.634 0 01-3.7 21.223 35.119 35.119 0 01-10.471 15.1 24.228 24.228 0 01-15.708 5.48 19.534 19.534 0 01-10.552-2.861 16.376 16.376 0 01-6.6-7.531h-1.29a27.62 27.62 0 01-22.15 10.393q-14.253 0-22.471-8.578t-8.217-23.481q0-16.994 10.8-27.384t28.194-10.39a97.35 97.35 0 0115.264 1.329 83.891 83.891 0 0113.731 3.182l-1.851 39.384q0 11.194 6.119 11.194 5.156 0 8.218-7.528t3.059-19.694a47.282 47.282 0 00-5.4-22.915 36.639 36.639 0 00-15.183-15.178 46.72 46.72 0 00-22.36-5.231q-16.268 0-28.269 6.686a44.7 44.7 0 00-18.4 19.289q-6.407 12.6-6.4 29.118 0 22.228 11.88 34.109t34.429 11.877a103.771 103.771 0 0018.767-1.893 124.348 124.348 0 0020.137-5.519V507.6q-17.237 7.33-38.26 7.33-30.593 0-47.72-16.109t-17.117-44.78a74.954 74.954 0 018.74-36.124 63.412 63.412 0 0124.895-25.452q16.148-9.22 37.168-9.22 17.72 0 31.655 7.246a51.378 51.378 0 0121.505 20.62q7.555 13.355 7.558 30.844zm-82.482 10.066q0 17 13.854 16.994 7.247 0 11.035-5.1t4.589-16.631l1.047-17.8a44.086 44.086 0 00-9.262-.9q-10.063 0-15.666 6.3t-5.591 17.126z"
              transform="translate(-801.946 -303.068)"
              fill="url(#prefix__z)"
            />
          </g>
          <path
            data-name="Path 10613"
            d="M504.159 75.571a56.665 56.665 0 0188.175-47.747l3.221-3.266a1.659 1.659 0 012.777.726l5.636 20.475a1.656 1.656 0 01-2.015 2.043l-20.555-5.36a1.665 1.665 0 01-.762-2.774l3.632-3.688a45.376 45.376 0 1021.976 39.2 1.826 1.826 0 011.638-1.845l7.918-.093a1.636 1.636 0 011.125.624l.066.066a2.15 2.15 0 01.492 1.392 56.666 56.666 0 01-113.327.243zm98.642-29.373a.456.456 0 000-.111l-5.636-20.48a.429.429 0 00-.723-.186l-3.941 3.992-.423-.3a55.452 55.452 0 1024.19 46.23.994.994 0 00-.138-.522l-.069-.069a1.778 1.778 0 00-.279-.252l-7.873.09c-.171 0-.42.336-.423.63a46.7 46.7 0 11-21.918-39.876l.648.408-4.706 4.775a.432.432 0 00-.111.423.438.438 0 00.3.3l20.569 5.369a.429.429 0 00.54-.42z"
            fill="#7d97f4"
          />
          <path
            data-name="Path 10614"
            d="M543.511 86.069h-16.328v-3.44l5.864-5.927q2.6-2.669 3.4-3.7a8.183 8.183 0 001.149-1.908 4.883 4.883 0 00.351-1.824 2.683 2.683 0 00-.774-2.1 3 3 0 00-2.07-.687 5.965 5.965 0 00-2.636.621 13.653 13.653 0 00-2.667 1.776l-2.7-3.179a17.577 17.577 0 012.858-2.079 10.448 10.448 0 012.478-.933 12.64 12.64 0 013-.33 8.86 8.86 0 013.866.8 6.168 6.168 0 012.606 2.234 5.972 5.972 0 01.924 3.3 8.055 8.055 0 01-.567 3.026 11.643 11.643 0 01-1.758 2.9 42.076 42.076 0 01-4.2 4.232l-3 2.828v.222h10.177z"
            fill="#7d97f4"
          />
          <path
            data-name="Path 10615"
            d="M562.709 81.222h-2.81v4.847h-4.826v-4.847h-9.967v-3.434l10.24-15.081h4.553v14.682h2.81zm-7.636-3.833v-3.962c0-.66.027-1.617.081-2.876s.1-1.986.126-2.187h-.126a18.192 18.192 0 01-1.422 2.555l-4.283 6.47z"
            fill="#7d97f4"
          />
          <path
            data-name="Path 10616"
            d="M576.575 62.707l-8.7 23.356h-4.427l8.7-23.356z"
            fill="#7d97f4"
          />
          <path
            data-name="Path 10617"
            d="M580.371 86.069l8.77-19.169h-11.517v-4.16h16.76v3.1l-8.845 20.231z"
            fill="#7d97f4"
          />
          <path
            data-name="Path 10618"
            d="M1967.847 597.7l.159 1.9a.328.328 0 10.654-.054l-.177-1.914a.319.319 0 10-.636.057z"
            transform="translate(-1377.622 -418.19)"
            fill="url(#prefix__A)"
          />
          <path
            data-name="Path 10619"
            d="M1968.94 618.809v1.9a.36.36 0 10.72 0v-1.92a.351.351 0 10-.7 0z"
            transform="translate(-1378.388 -432.961)"
            fill="url(#prefix__B)"
          />
          <path
            data-name="Path 10620"
            d="M1967.8 639.932l-.171 1.893a.4.4 0 00.786.069l.153-1.917a.384.384 0 00-.765-.066z"
            transform="translate(-1377.471 -447.746)"
            fill="url(#prefix__C)"
          />
          <path
            data-name="Path 10621"
            d="M1964.922 660.918l-.327 1.863a.429.429 0 00.843.147l.3-1.9a.417.417 0 10-.822-.141z"
            transform="translate(-1375.345 -462.437)"
            fill="url(#prefix__D)"
          />
          <path
            data-name="Path 10622"
            d="M1960.341 681.673l-.474 1.839a.462.462 0 00.333.561.456.456 0 00.558-.33l.459-1.863a.45.45 0 00-.873-.222z"
            transform="translate(-1372.026 -476.98)"
            fill="url(#prefix__E)"
          />
          <path
            data-name="Path 10623"
            d="M1954.179 702.2l-.615 1.8a.492.492 0 00.93.318l.6-1.827a.483.483 0 00-.9-.3z"
            transform="translate(-1367.611 -491.422)"
            fill="url(#prefix__F)"
          />
          <path
            data-name="Path 10624"
            d="M1946.44 721.9l-.75 1.749a.525.525 0 10.966.414l.741-1.779a.516.516 0 00-.948-.4z"
            transform="translate(-1362.082 -505.176)"
            fill="url(#prefix__G)"
          />
          <path
            data-name="Path 10625"
            d="M1937.251 741.048l-.879 1.686a.558.558 0 10.99.516l.87-1.716a.547.547 0 10-.972-.5z"
            transform="translate(-1355.544 -518.575)"
            fill="url(#prefix__H)"
          />
          <path
            data-name="Path 10626"
            d="M1926.77 759.589l-1 1.614a.6.6 0 001 .621l1-1.647a.579.579 0 00-.99-.6z"
            transform="translate(-1348.138 -531.579)"
            fill="url(#prefix__I)"
          />
          <path
            data-name="Path 10627"
            d="M1914.76 777.25l-1.116 1.536a.624.624 0 001.008.735l1.119-1.569a.613.613 0 10-1-.717z"
            transform="translate(-1339.601 -543.949)"
            fill="url(#prefix__J)"
          />
          <path
            data-name="Path 10628"
            d="M1901.531 794.029l-1.227 1.446a.657.657 0 001 .852l1.233-1.482a.645.645 0 00-.987-.831z"
            transform="translate(-1330.229 -555.714)"
            fill="url(#prefix__K)"
          />
          <path
            data-name="Path 10629"
            d="M1887.109 809.806l-1.335 1.35a.688.688 0 10.978.969l1.344-1.386a.678.678 0 00-.969-.948z"
            transform="translate(-1320.028 -566.785)"
            fill="url(#prefix__L)"
          />
          <path
            data-name="Path 10630"
            d="M1871.594 824.408l-1.434 1.239a.723.723 0 00.945 1.092l1.446-1.278a.711.711 0 00-.936-1.071z"
            transform="translate(-1309.08 -577.016)"
            fill="url(#prefix__M)"
          />
          <path
            data-name="Path 10631"
            d="M1855 837.739l-1.527 1.119a.753.753 0 00.9 1.2l1.545-1.158a.75.75 0 00-.9-1.2z"
            transform="translate(-1297.383 -586.352)"
            fill="url(#prefix__N)"
          />
          <path
            data-name="Path 10632"
            d="M1837.216 849.882l-1.611.993a.778.778 0 00.816 1.326l1.638-1.023a.774.774 0 00-.813-1.314z"
            transform="translate(-1284.786 -594.908)"
            fill="url(#prefix__O)"
          />
          <path
            data-name="Path 10633"
            d="M1818.539 860.438l-1.689.852h-.018a.8.8 0 10.72 1.422l1.719-.882a.792.792 0 00-.717-1.41z"
            transform="translate(-1271.571 -602.315)"
            fill="url(#prefix__P)"
          />
          <path
            data-name="Path 10634"
            d="M1799.35 869.42l-1.755.7h-.021a.816.816 0 00.6 1.515l1.8-.729a.81.81 0 00-.6-1.5z"
            transform="translate(-1258.089 -608.631)"
            fill="url(#prefix__Q)"
          />
          <path
            data-name="Path 10635"
            d="M1779.242 876.664l-1.8.558h-.021a.832.832 0 00.492 1.59l1.842-.582a.826.826 0 10-.492-1.578z"
            transform="translate(-1243.902 -613.7)"
            fill="url(#prefix__R)"
          />
          <path
            data-name="Path 10636"
            d="M1758.7 882.359l-1.848.417h-.018a.852.852 0 10.375 1.662l1.88-.438a.846.846 0 10-.378-1.65z"
            transform="translate(-1229.438 -617.7)"
            fill="url(#prefix__S)"
          />
          <path
            data-name="Path 10637"
            d="M1737.749 886.459l-1.875.279h-.018a.87.87 0 10.255 1.719l1.907-.3a.864.864 0 10-.258-1.71z"
            transform="translate(-1214.665 -620.577)"
            fill="url(#prefix__T)"
          />
          <path
            data-name="Path 10638"
            d="M1717.03 889.056l-1.89.141h-.018a.9.9 0 00.135 1.773l1.923-.156a.883.883 0 00-.138-1.761z"
            transform="translate(-1200.214 -622.406)"
            fill="url(#prefix__U)"
          />
          <path
            data-name="Path 10639"
            d="M1695.52 890.122l-1.893.015h-.018a.9.9 0 000 1.8l1.932-.027a.9.9 0 00-.021-1.8z"
            transform="translate(-1185.009 -623.148)"
            fill="url(#prefix__V)"
          />
          <path
            data-name="Path 10640"
            d="M1674.265 889.584l-1.89-.108h-.018a.925.925 0 10-.1 1.848l1.926.1a.921.921 0 10.1-1.839z"
            transform="translate(-1170.077 -622.703)"
            fill="url(#prefix__W)"
          />
          <path
            data-name="Path 10641"
            d="M1653.04 887.653l-1.883-.222a.945.945 0 10-.222 1.875l1.917.213a.939.939 0 00.216-1.863z"
            transform="translate(-1155.15 -621.263)"
            fill="url(#prefix__X)"
          />
          <path
            data-name="Path 10642"
            d="M1632.208 884.517l-1.865-.33h-.018a.963.963 0 00-.333 1.9l1.9.327a.958.958 0 10.33-1.887z"
            transform="translate(-1140.566 -618.994)"
            fill="url(#prefix__Y)"
          />
          <path
            data-name="Path 10643"
            d="M1611.345 880.179l-1.845-.429h-.018a.981.981 0 00-.444 1.911l1.878.429a.975.975 0 10.441-1.9z"
            transform="translate(-1125.902 -615.877)"
            fill="url(#prefix__Z)"
          />
          <path
            data-name="Path 10644"
            d="M1590.836 874.738l-1.821-.531a1 1 0 10-.558 1.92l1.856.528a.994.994 0 10.549-1.911z"
            transform="translate(-1111.521 -611.986)"
            fill="url(#prefix__aa)"
          />
          <path
            data-name="Path 10645"
            d="M1570.567 868.256l-1.8-.618a1.017 1.017 0 10-.666 1.923l1.827.618a1.011 1.011 0 00.654-1.914z"
            transform="translate(-1097.296 -607.377)"
            fill="url(#prefix__ab)"
          />
          <path
            data-name="Path 10646"
            d="M1550.693 860.784l-1.761-.708a1.036 1.036 0 10-.771 1.923l1.8.708a1.03 1.03 0 10.762-1.914z"
            transform="translate(-1083.36 -602.069)"
            fill="url(#prefix__ac)"
          />
          <path
            data-name="Path 10647"
            d="M1531.173 852.366l-1.725-.789a1.054 1.054 0 00-.876 1.917l1.758.792a1.05 1.05 0 00.867-1.911z"
            transform="translate(-1069.671 -596.105)"
            fill="url(#prefix__ad)"
          />
          <path
            data-name="Path 10648"
            d="M1511.979 842.991l-1.689-.87a1.074 1.074 0 10-.984 1.908l1.722.876A1.068 1.068 0 101512 843z"
            transform="translate(-1056.185 -589.457)"
            fill="url(#prefix__ae)"
          />
          <path
            data-name="Path 10649"
            d="M1493.434 832.867l-1.647-.939a1.081 1.081 0 10-1.071 1.877l1.671.951a1.078 1.078 0 101.065-1.875z"
            transform="translate(-1043.219 -582.317)"
            fill="url(#prefix__af)"
          />
          <path
            data-name="Path 10650"
            d="M1475.162 821.908l-1.613-1a1.086 1.086 0 10-1.149 1.842l1.638 1.017a1.084 1.084 0 001.143-1.842z"
            transform="translate(-1030.4 -574.571)"
            fill="url(#prefix__ag)"
          />
          <path
            data-name="Path 10651"
            d="M1457.254 810.214l-1.578-1.062a1.092 1.092 0 10-1.221 1.8l1.6 1.071a1.089 1.089 0 101.218-1.8z"
            transform="translate(-1017.821 -566.299)"
            fill="url(#prefix__ah)"
          />
          <path
            data-name="Path 10652"
            d="M1440.131 798.189l-1.539-1.116a1.1 1.1 0 00-1.29 1.776l1.557 1.125a1.1 1.1 0 001.284-1.776z"
            transform="translate(-1005.908 -557.882)"
            fill="url(#prefix__ai)"
          />
          <path
            data-name="Path 10653"
            d="M1423.1 785.384l-1.5-1.164a1.1 1.1 0 00-1.353 1.746l1.521 1.176a1.1 1.1 0 101.347-1.746z"
            transform="translate(-993.971 -548.856)"
            fill="url(#prefix__aj)"
          />
          <path
            data-name="Path 10654"
            d="M1406.442 772.094l-1.473-1.2a1.11 1.11 0 10-1.407 1.716l1.5 1.218a1.11 1.11 0 101.4-1.719z"
            transform="translate(-982.285 -539.498)"
            fill="url(#prefix__ak)"
          />
          <path
            data-name="Path 10655"
            d="M1390.266 758.463l-1.443-1.245a1.116 1.116 0 10-1.458 1.692l1.455 1.254a1.122 1.122 0 101.464-1.7z"
            transform="translate(-970.976 -529.925)"
            fill="url(#prefix__al)"
          />
          <path
            data-name="Path 10656"
            d="M1374.234 744.245l-1.413-1.281a1.122 1.122 0 10-1.5 1.665l1.428 1.287a1.122 1.122 0 001.5-1.665z"
            transform="translate(-959.726 -519.906)"
            fill="url(#prefix__am)"
          />
          <path
            data-name="Path 10657"
            d="M1358.755 729.911l-1.386-1.308a1.129 1.129 0 00-1.548 1.644l1.4 1.314a1.128 1.128 0 001.542-1.644z"
            transform="translate(-948.917 -509.867)"
            fill="url(#prefix__an)"
          />
          <path
            data-name="Path 10658"
            d="M1343.428 715.2l-1.365-1.332a1.135 1.135 0 10-1.584 1.626l1.377 1.338a1.134 1.134 0 001.578-1.626z"
            transform="translate(-938.184 -499.542)"
            fill="url(#prefix__ao)"
          />
          <path
            data-name="Path 10659"
            d="M1328.307 700.232l-1.347-1.356a1.141 1.141 0 10-1.617 1.611l1.356 1.359a1.14 1.14 0 101.611-1.611z"
            transform="translate(-927.596 -489.037)"
            fill="url(#prefix__ap)"
          />
          <path
            data-name="Path 10660"
            d="M1313.414 685.06l-1.332-1.374a1.146 1.146 0 10-1.647 1.6l1.341 1.374a1.146 1.146 0 101.641-1.6z"
            transform="translate(-917.166 -478.393)"
            fill="url(#prefix__aq)"
          />
          <path
            data-name="Path 10661"
            d="M1298.675 669.726l-1.32-1.386a1.153 1.153 0 00-1.674 1.587l1.326 1.386a1.152 1.152 0 001.665-1.59z"
            transform="translate(-906.842 -467.642)"
            fill="url(#prefix__ar)"
          />
          <path
            data-name="Path 10662"
            d="M1283.982 654.18l-1.307-1.395a1.161 1.161 0 10-1.695 1.584l1.314 1.395a1.158 1.158 0 001.686-1.587z"
            transform="translate(-896.528 -456.721)"
            fill="url(#prefix__as)"
          />
          <path
            data-name="Path 10663"
            d="M1269.544 638.719l-1.3-1.4a1.165 1.165 0 10-1.709 1.584l1.3 1.4a1.162 1.162 0 101.7-1.584z"
            transform="translate(-886.442 -445.916)"
            fill="url(#prefix__at)"
          />
          <path
            data-name="Path 10664"
            d="M1255.142 623.2l-1.3-1.4a1.173 1.173 0 00-1.722 1.59l1.3 1.4a1.171 1.171 0 001.716-1.593z"
            transform="translate(-876.374 -435.071)"
            fill="url(#prefix__au)"
          />
          <path
            data-name="Path 10665"
            d="M1240.6 607.519l-1.3-1.4a1.177 1.177 0 00-1.728 1.6l1.3 1.4a1.176 1.176 0 001.725-1.6z"
            transform="translate(-866.162 -424.071)"
            fill="url(#prefix__av)"
          />
          <path
            data-name="Path 10666"
            d="M1226.094 591.949l-1.3-1.4a1.183 1.183 0 00-1.731 1.614l1.3 1.395a1.182 1.182 0 101.728-1.614z"
            transform="translate(-856 -413.174)"
            fill="url(#prefix__aw)"
          />
          <path
            data-name="Path 10667"
            d="M1211.243 576.174l-1.314-1.392a1.2 1.2 0 10-1.731 1.635l1.317 1.386a1.2 1.2 0 101.725-1.632z"
            transform="translate(-845.513 -402.053)"
            fill="url(#prefix__ax)"
          />
          <path
            data-name="Path 10668"
            d="M1196.984 561.244l-1.329-1.38a1.2 1.2 0 00-1.722 1.656l1.326 1.374a1.2 1.2 0 101.719-1.656z"
            transform="translate(-835.651 -391.751)"
            fill="url(#prefix__ay)"
          />
          <path
            data-name="Path 10669"
            d="M1181.95 545.82l-1.344-1.368a1.2 1.2 0 10-1.712 1.686l1.338 1.359a1.2 1.2 0 001.71-1.683z"
            transform="translate(-825.063 -380.914)"
            fill="url(#prefix__az)"
          />
          <path
            data-name="Path 10670"
            d="M1166.9 530.756l-1.365-1.35a1.208 1.208 0 00-1.7 1.719l1.356 1.338a1.206 1.206 0 001.695-1.716z"
            transform="translate(-814.515 -370.387)"
            fill="url(#prefix__aA)"
          />
          <path
            data-name="Path 10671"
            d="M1151.623 515.928l-1.386-1.326a1.213 1.213 0 10-1.68 1.752l1.38 1.317a1.212 1.212 0 101.674-1.755z"
            transform="translate(-803.806 -360.031)"
            fill="url(#prefix__aB)"
          />
          <path
            data-name="Path 10672"
            d="M1136.085 501.4l-1.416-1.3a1.217 1.217 0 00-1.638 1.8l1.4 1.293a1.211 1.211 0 001.641-1.782z"
            transform="translate(-792.919 -349.894)"
            fill="url(#prefix__aC)"
          />
          <path
            data-name="Path 10673"
            d="M1120.278 487.2l-1.446-1.269a1.2 1.2 0 10-1.59 1.8l1.431 1.26a1.2 1.2 0 001.6-1.8z"
            transform="translate(-781.86 -339.983)"
            fill="url(#prefix__aD)"
          />
          <path
            data-name="Path 10674"
            d="M1104.111 473.369l-1.473-1.233a1.2 1.2 0 10-1.542 1.842l1.47 1.221a1.2 1.2 0 101.548-1.842z"
            transform="translate(-770.54 -330.342)"
            fill="url(#prefix__aE)"
          />
          <path
            data-name="Path 10675"
            d="M1087.6 459.936l-1.5-1.2a1.2 1.2 0 10-1.5 1.878l1.5 1.182a1.2 1.2 0 001.5-1.875z"
            transform="translate(-758.973 -320.974)"
            fill="url(#prefix__aF)"
          />
          <path
            data-name="Path 10676"
            d="M1070.446 446.839l-1.542-1.146a1.2 1.2 0 10-1.422 1.914l1.524 1.134a1.2 1.2 0 101.425-1.911z"
            transform="translate(-746.89 -311.799)"
            fill="url(#prefix__aG)"
          />
          <path
            data-name="Path 10677"
            d="M1053.06 434.393l-1.581-1.095a1.2 1.2 0 10-1.353 1.95l1.557 1.086a1.2 1.2 0 101.359-1.95z"
            transform="translate(-734.69 -303.121)"
            fill="url(#prefix__aH)"
          />
          <path
            data-name="Path 10678"
            d="M1035.723 422.856l-1.623-1.044a1.182 1.182 0 10-1.278 1.989l1.6 1.032a1.185 1.185 0 101.284-1.989z"
            transform="translate(-722.664 -295.177)"
            fill="url(#prefix__aI)"
          />
          <path
            data-name="Path 10679"
            d="M1017.673 411.756l-1.659-.981a1.179 1.179 0 00-1.2 2.028l1.635.969a1.179 1.179 0 001.2-2.028z"
            transform="translate(-710.058 -287.482)"
            fill="url(#prefix__aJ)"
          />
          <path
            data-name="Path 10680"
            d="M999.064 401.244l-1.692-.918a1.173 1.173 0 10-1.122 2.061l1.665.9a1.174 1.174 0 001.125-2.061z"
            transform="translate(-697.013 -280.167)"
            fill="url(#prefix__aK)"
          />
          <path
            data-name="Path 10681"
            d="M980.162 391.463l-1.722-.858a1.172 1.172 0 00-1.041 2.1l1.7.849a1.173 1.173 0 101.047-2.1z"
            transform="translate(-683.789 -273.376)"
            fill="url(#prefix__aL)"
          />
          <path
            data-name="Path 10682"
            d="M960.915 382.371l-1.758-.795a1.164 1.164 0 10-.963 2.121l1.728.786a1.167 1.167 0 00.966-2.124z"
            transform="translate(-670.322 -267.067)"
            fill="url(#prefix__aM)"
          />
          <path
            data-name="Path 10683"
            d="M941.38 373.986l-1.782-.729a1.159 1.159 0 00-.879 2.145l1.758.723a1.161 1.161 0 10.882-2.148z"
            transform="translate(-656.663 -261.256)"
            fill="url(#prefix__aN)"
          />
          <path
            data-name="Path 10684"
            d="M921.545 366.277l-1.8-.666a1.155 1.155 0 00-.8 2.166l1.782.66a1.158 1.158 0 00.8-2.169z"
            transform="translate(-642.793 -255.913)"
            fill="url(#prefix__aO)"
          />
          <path
            data-name="Path 10685"
            d="M901.443 359.324l-1.827-.6a1.15 1.15 0 00-.72 2.184l1.8.6a1.152 1.152 0 10.726-2.183z"
            transform="translate(-628.734 -251.102)"
            fill="url(#prefix__aP)"
          />
          <path
            data-name="Path 10686"
            d="M881.206 353.079l-1.848-.537a1.146 1.146 0 00-.639 2.2l1.824.534a1.147 1.147 0 00.645-2.2z"
            transform="translate(-614.616 -246.792)"
            fill="url(#prefix__aQ)"
          />
          <path
            data-name="Path 10687"
            d="M860.553 347.5l-1.866-.474a1.14 1.14 0 10-.558 2.211l1.842.471a1.143 1.143 0 00.564-2.214z"
            transform="translate(-600.145 -242.93)"
            fill="url(#prefix__aR)"
          />
          <path
            data-name="Path 10688"
            d="M839.816 342.678l-1.881-.408a1.137 1.137 0 00-.48 2.223l1.86.4a1.137 1.137 0 10.483-2.222z"
            transform="translate(-585.647 -239.605)"
            fill="url(#prefix__aS)"
          />
          <path
            data-name="Path 10689"
            d="M818.928 338.59l-1.9-.342a1.132 1.132 0 00-.4 2.229l1.872.339a1.134 1.134 0 10.4-2.229z"
            transform="translate(-571.045 -236.796)"
            fill="url(#prefix__aT)"
          />
          <path
            data-name="Path 10690"
            d="M797.979 335.256l-1.908-.273a1.128 1.128 0 00-.321 2.232l1.881.273a1.128 1.128 0 00.324-2.232z"
            transform="translate(-556.425 -234.517)"
            fill="url(#prefix__aU)"
          />
          <path
            data-name="Path 10691"
            d="M776.79 332.631l-1.914-.207a1.122 1.122 0 00-.243 2.232l1.889.207a1.122 1.122 0 10.243-2.232z"
            transform="translate(-541.595 -232.726)"
            fill="url(#prefix__aV)"
          />
          <path
            data-name="Path 10692"
            d="M755.586 330.771l-1.92-.138a1.117 1.117 0 00-.159 2.229l1.9.138a1.119 1.119 0 10.165-2.231z"
            transform="translate(-526.78 -231.475)"
            fill="url(#prefix__aW)"
          />
          <path
            data-name="Path 10693"
            d="M734.427 329.669l-1.927-.069a1.113 1.113 0 00-.081 2.223l1.9.072a1.114 1.114 0 10.084-2.225z"
            transform="translate(-512.023 -230.754)"
            fill="url(#prefix__aX)"
          />
          <path
            data-name="Path 10694"
            d="M713.062 329.306h-1.926a1.107 1.107 0 100 2.214h1.9a1.11 1.11 0 100-2.219z"
            transform="translate(-497.069 -230.544)"
            fill="url(#prefix__aY)"
          />
          <path
            data-name="Path 10695"
            d="M691.876 329.578l-1.923.069a1.1 1.1 0 00.081 2.2l1.9-.066a1.1 1.1 0 10-.075-2.208z"
            transform="translate(-482.298 -230.738)"
            fill="url(#prefix__aZ)"
          />
          <path
            data-name="Path 10696"
            d="M670.539 330.6l-1.92.141a1.1 1.1 0 10.156 2.19l1.9-.135a1.1 1.1 0 10-.156-2.2z"
            transform="translate(-467.365 -231.454)"
            fill="url(#prefix__ba)"
          />
          <path
            data-name="Path 10697"
            d="M649.233 332.415l-1.914.207a1.095 1.095 0 10.237 2.175l1.89-.2a1.1 1.1 0 10-.234-2.178z"
            transform="translate(-452.45 -232.72)"
            fill="url(#prefix__bb)"
          />
          <path
            data-name="Path 10698"
            d="M628.306 334.991l-1.9.279a1.089 1.089 0 00.318 2.154l1.878-.273a1.092 1.092 0 00-.3-2.16z"
            transform="translate(-437.891 -234.525)"
            fill="url(#prefix__bc)"
          />
          <path
            data-name="Path 10699"
            d="M607.262 338.4l-1.893.36a1.084 1.084 0 10.4 2.13l1.866-.348h.015a1.086 1.086 0 10-.4-2.135z"
            transform="translate(-423.181 -236.905)"
            fill="url(#prefix__bd)"
          />
          <path
            data-name="Path 10700"
            d="M586.328 342.72l-1.878.441a1.08 1.08 0 10.495 2.1l1.848-.429a1.083 1.083 0 00-.492-2.1z"
            transform="translate(-408.537 -239.939)"
            fill="url(#prefix__be)"
          />
          <path
            data-name="Path 10701"
            d="M565.851 347.914l-1.857.528a1.077 1.077 0 10.6 2.069l1.827-.519h.03a1.079 1.079 0 10-.6-2.073z"
            transform="translate(-394.29 -243.549)"
            fill="url(#prefix__bf)"
          />
          <path
            data-name="Path 10702"
            d="M545.546 354.143l-1.824.624a1.066 1.066 0 00.687 2.019l1.8-.6a1.068 1.068 0 00-.681-2.022z"
            transform="translate(-380.136 -247.922)"
            fill="url(#prefix__bg)"
          />
          <path
            data-name="Path 10703"
            d="M525.609 361.345l-1.8.723a1.048 1.048 0 10.786 1.944l1.758-.7h.018a1.053 1.053 0 10-.78-1.956z"
            transform="translate(-366.243 -252.931)"
            fill="url(#prefix__bh)"
          />
          <path
            data-name="Path 10704"
            d="M506.165 369.738l-1.746.828a1.037 1.037 0 00.9 1.869l1.716-.8a1.039 1.039 0 00-.882-1.881z"
            transform="translate(-352.716 -258.793)"
            fill="url(#prefix__bi)"
          />
          <path
            data-name="Path 10705"
            d="M487.254 379.331l-1.689.939a1.021 1.021 0 00.993 1.785l1.659-.9h.018a1.026 1.026 0 10-.987-1.8z"
            transform="translate(-339.561 -265.497)"
            fill="url(#prefix__bj)"
          />
          <path
            data-name="Path 10706"
            d="M469.053 390.188l-1.62 1.062a1.006 1.006 0 101.1 1.686l1.59-1.026h.018a1.011 1.011 0 00-1.095-1.7z"
            transform="translate(-326.915 -273.087)"
            fill="url(#prefix__bk)"
          />
          <path
            data-name="Path 10707"
            d="M451.559 402.29l-1.539 1.176a.993.993 0 101.2 1.575h.015l1.5-1.143.021-.015a1 1 0 00-1.2-1.587z"
            transform="translate(-314.727 -281.524)"
            fill="url(#prefix__bl)"
          />
          <path
            data-name="Path 10708"
            d="M435.329 415.754l-1.437 1.3a.978.978 0 101.308 1.446h.018l1.4-1.263.018-.015a.984.984 0 00-1.311-1.464z"
            transform="translate(-303.505 -290.922)"
            fill="url(#prefix__bm)"
          />
          <path
            data-name="Path 10709"
            d="M420.319 430.474L419 431.9a.964.964 0 101.413 1.311h.015l1.29-1.377.018-.018a.969.969 0 10-1.413-1.326z"
            transform="translate(-293.148 -301.166)"
            fill="url(#prefix__bn)"
          />
          <path
            data-name="Path 10710"
            d="M406.475 446.376l-1.185 1.542a.951.951 0 101.5 1.155l.015-.018 1.152-1.5.018-.021a.954.954 0 10-1.5-1.17z"
            transform="translate(-283.551 -312.197)"
            fill="url(#prefix__bo)"
          />
          <path
            data-name="Path 10711"
            d="M394.613 463.857l-1.02 1.65a.936.936 0 101.593.984v-.021l1-1.6.015-.024a.942.942 0 10-1.6-1z"
            transform="translate(-275.445 -324.4)"
            fill="url(#prefix__bp)"
          />
          <path
            data-name="Path 10712"
            d="M384.387 482.368l-.852 1.743a.921.921 0 101.653.81v-.021l.837-1.689v-.024a.927.927 0 10-1.659-.822z"
            transform="translate(-268.424 -337.308)"
            fill="url(#prefix__bq)"
          />
          <path
            data-name="Path 10713"
            d="M376.059 501.946l-.687 1.815a.907.907 0 001.7.642v-.021l.675-1.761v-.021a.912.912 0 10-1.7-.654z"
            transform="translate(-262.745 -350.995)"
            fill="url(#prefix__br)"
          />
          <path
            data-name="Path 10714"
            d="M369.467 522.035l-.516 1.863a.9.9 0 101.722.477v-.018l.513-1.8v-.024a.9.9 0 10-1.728-.486z"
            transform="translate(-258.244 -364.974)"
            fill="url(#prefix__bs)"
          />
          <path
            data-name="Path 10715"
            d="M364.859 542.788l-.354 1.9a.88.88 0 101.731.321v-.021l.354-1.857v-.021a.885.885 0 10-1.737-.33z"
            transform="translate(-255.168 -379.465)"
            fill="url(#prefix__bt)"
          />
          <path
            data-name="Path 10716"
            d="M361.995 563.989l-.189 1.926a.867.867 0 001.725.168v-.018l.192-1.881v-.021a.87.87 0 00-1.731-.177z"
            transform="translate(-253.287 -394.292)"
            fill="url(#prefix__bu)"
          />
          <path
            data-name="Path 10717"
            d="M360.939 585.4l-.024 1.935a.852.852 0 101.7.024v-.018l.036-1.893v-.021a.858.858 0 00-1.713-.03z"
            transform="translate(-252.664 -409.272)"
            fill="url(#prefix__bv)"
          />
          <path
            data-name="Path 10718"
            d="M361.33 606.743l.135 1.929a.837.837 0 101.671-.12v-.018l-.126-1.887v-.021a.843.843 0 00-1.68.111z"
            transform="translate(-252.956 -424.17)"
            fill="url(#prefix__bw)"
          />
          <path
            data-name="Path 10719"
            d="M363.469 627.924l.3 1.911a.825.825 0 101.629-.255l-.282-1.872v-.021a.828.828 0 00-1.638.249z"
            transform="translate(-254.453 -438.942)"
            fill="url(#prefix__bx)"
          />
          <path
            data-name="Path 10720"
            d="M367.371 648.87l.477 1.878a.81.81 0 101.572-.384v-.018l-.462-1.847v-.021a.813.813 0 00-1.581.381z"
            transform="translate(-257.173 -453.552)"
            fill="url(#prefix__by)"
          />
          <path
            data-name="Path 10721"
            d="M373.092 669.536l.624 1.833a.795.795 0 001.5-.513v-.018l-.6-1.8v-.018a.8.8 0 00-1.518.507z"
            transform="translate(-261.172 -468.011)"
            fill="url(#prefix__bz)"
          />
          <path
            data-name="Path 10722"
            d="M380.518 689.371l.786 1.767a.783.783 0 001.428-.636v-.015l-.768-1.731v-.018a.786.786 0 10-1.437.63z"
            transform="translate(-266.334 -481.813)"
            fill="url(#prefix__bA)"
          />
          <path
            data-name="Path 10723"
            d="M389.85 708.743l.948 1.686a.768.768 0 001.338-.75l-.927-1.653v-.021a.771.771 0 00-1.347.75z"
            transform="translate(-272.862 -495.385)"
            fill="url(#prefix__bB)"
          />
          <path
            data-name="Path 10724"
            d="M400.931 727.025l1.11 1.587a.744.744 0 001.221-.846v-.021l-1.086-1.545v-.018a.75.75 0 00-1.236.852z"
            transform="translate(-280.593 -508.16)"
            fill="url(#prefix__bC)"
          />
          <path
            data-name="Path 10725"
            d="M413.766 744.153l1.263 1.464a.718.718 0 101.092-.933l-.015-.015-1.221-1.44-.015-.018a.726.726 0 00-1.107.939z"
            transform="translate(-289.549 -520.138)"
            fill="url(#prefix__bD)"
          />
          <path
            data-name="Path 10726"
            d="M428.264 759.859l1.407 1.329a.693.693 0 00.954-1h-.015l-1.374-1.326v-.015a.7.7 0 10-.969 1.011z"
            transform="translate(-299.665 -531.118)"
            fill="url(#prefix__bE)"
          />
          <path
            data-name="Path 10727"
            d="M444.255 774.072l1.533 1.179a.666.666 0 10.816-1.053h-.015l-1.5-1.167-.015-.015a.675.675 0 10-.831 1.065z"
            transform="translate(-310.819 -541.074)"
            fill="url(#prefix__bF)"
          />
          <path
            data-name="Path 10728"
            d="M461.7 786.673l1.635 1.026a.642.642 0 00.687-1.086H464l-1.6-1.02h-.018a.651.651 0 00-.7 1.095z"
            transform="translate(-323.03 -549.923)"
            fill="url(#prefix__bG)"
          />
          <path
            data-name="Path 10729"
            d="M480.062 797.447l1.725.867a.618.618 0 00.561-1.1h-.015l-1.689-.867h-.015a.624.624 0 10-.57 1.11z"
            transform="translate(-335.836 -557.46)"
            fill="url(#prefix__bH)"
          />
          <path
            data-name="Path 10730"
            d="M499.461 806.53l1.8.708a.6.6 0 00.441-1.1h-.015l-1.758-.714a.6.6 0 10-.453 1.113z"
            transform="translate(-349.405 -563.832)"
            fill="url(#prefix__bI)"
          />
          <path
            data-name="Path 10731"
            d="M519.447 813.841l1.848.552a.567.567 0 00.33-1.086h-.015l-1.8-.558a.576.576 0 10-.339 1.1z"
            transform="translate(-363.353 -568.963)"
            fill="url(#prefix__bJ)"
          />
          <path
            data-name="Path 10732"
            d="M540.23 819.485l1.884.393a.543.543 0 00.225-1.062l-1.857-.4a.552.552 0 00-.234 1.077z"
            transform="translate(-377.927 -572.951)"
            fill="url(#prefix__bK)"
          />
          <path
            data-name="Path 10733"
            d="M561.153 823.287l1.911.231a.517.517 0 10.129-1.026l-1.884-.246a.525.525 0 10-.135 1.041z"
            transform="translate(-392.531 -575.634)"
            fill="url(#prefix__bL)"
          />
          <path
            data-name="Path 10734"
            d="M582.359 825.352l1.923.072a.492.492 0 00.042-.984l-1.9-.087a.5.5 0 10-.045 1z"
            transform="translate(-407.348 -577.111)"
            fill="url(#prefix__bM)"
          />
          <path
            data-name="Path 10735"
            d="M603.78 825.463l1.923-.09a.468.468 0 00-.039-.933l-1.9.075a.474.474 0 10.036.948z"
            transform="translate(-422.357 -577.174)"
            fill="url(#prefix__bN)"
          />
          <path
            data-name="Path 10736"
            d="M625.057 823.552l1.911-.255a.442.442 0 10-.114-.876l-1.89.24a.454.454 0 00.114.9z"
            transform="translate(-437.24 -575.758)"
            fill="url(#prefix__bO)"
          />
          <path
            data-name="Path 10737"
            d="M646.118 819.835l1.878-.423a.42.42 0 00.3-.5.414.414 0 00-.495-.3l-1.86.4a.424.424 0 00.18.828z"
            transform="translate(-451.969 -573.088)"
            fill="url(#prefix__bP)"
          />
          <path
            data-name="Path 10738"
            d="M666.858 814.182l1.827-.6a.393.393 0 00-.237-.747l-1.8.57a.4.4 0 10.24.762z"
            transform="translate(-466.502 -569.043)"
            fill="url(#prefix__bQ)"
          />
          <path
            data-name="Path 10739"
            d="M686.9 806.682l1.767-.762a.369.369 0 00-.3-.675l-1.752.741a.376.376 0 00.3.69z"
            transform="translate(-480.516 -563.715)"
            fill="url(#prefix__bR)"
          />
          <path
            data-name="Path 10740"
            d="M706.21 797.341l1.68-.933a.342.342 0 00-.327-.6l-1.671.9a.353.353 0 00.315.633z"
            transform="translate(-494.035 -557.106)"
            fill="url(#prefix__bS)"
          />
          <path
            data-name="Path 10741"
            d="M724.515 786.649l1.239-.855a.318.318 0 10-.36-.525l-1.23.834a.324.324 0 10.348.546z"
            transform="translate(-506.85 -549.713)"
            fill="url(#prefix__bT)"
          />
          <path
            data-name="Path 10742"
            d="M139.684 111.263a1.959 1.959 0 01-1.845-1.3l-2.729-7.711a39.657 39.657 0 01-10.7-4.337l-7.327 3.647a1.953 1.953 0 01-2.243-.36l-7.57-7.453a1.959 1.959 0 01-.4-2.235l3.524-7.387a39.706 39.706 0 01-4.5-10.633l-7.756-2.6a1.953 1.953 0 01-1.332-1.836l-.087-10.628a1.953 1.953 0 011.3-1.857l7.711-2.729a39.767 39.767 0 014.334-10.708l-3.644-7.327a1.953 1.953 0 01.354-2.229l7.45-7.573a1.953 1.953 0 012.235-.393l7.381 3.512a39.718 39.718 0 0110.633-4.5l2.594-7.768a1.962 1.962 0 011.836-1.332l10.624-.087h.015a1.952 1.952 0 011.841 1.3l2.729 7.712a39.651 39.651 0 0110.714 4.325l7.333-3.635a1.962 1.962 0 012.24.354l7.573 7.45a1.956 1.956 0 01.393 2.235l-3.527 7.393a39.738 39.738 0 014.5 10.63l7.753 2.6a1.962 1.962 0 011.335 1.836l.084 10.624a1.952 1.952 0 01-1.3 1.86l-7.708 2.729a39.756 39.756 0 01-4.337 10.7l3.644 7.327a1.956 1.956 0 01-.357 2.244l-7.447 7.57a1.95 1.95 0 01-2.234.393l-7.39-3.524a39.7 39.7 0 01-10.63 4.5l-2.6 7.756a1.961 1.961 0 01-1.836 1.332l-10.624.087zM124.52 95.12l.579.351a37.3 37.3 0 0011.215 4.544l.66.15 3.062 8.644 9.9-.081 2.918-8.7.657-.159a37.321 37.321 0 0011.155-4.73l.57-.372 8.284 3.953 6.95-7.063-4.088-8.218.354-.579a37.322 37.322 0 004.541-11.215l.15-.66 8.64-3.065-.081-9.9-8.7-2.918-.159-.657a37.268 37.268 0 00-4.724-11.14l-.345-.576 3.95-8.284-7.078-6.949-8.218 4.088-.576-.354a37.309 37.309 0 00-11.218-4.553l-.66-.15-3.059-8.647-9.913.1-2.915 8.7-.66.162a37.266 37.266 0 00-11.14 4.724l-.573.363-8.281-3.959-6.949 7.063 4.085 8.215-.351.579a37.319 37.319 0 00-4.529 11.218l-.15.66-8.659 3.068.081 9.9 8.7 2.918.159.66a37.353 37.353 0 004.727 11.14l.36.573-3.953 8.284 7.066 6.949zm10.906-69.477zm9.04 64.741a26.859 26.859 0 11-.2-53.717 27.194 27.194 0 015.7.556 1.227 1.227 0 11-.5 2.4 24.394 24.394 0 1015.872 11.194 1.23 1.23 0 012.1-1.278 26.859 26.859 0 01-22.717 40.836z"
            fill="#7d97f4"
          />
          <path
            data-name="Path 10743"
            d="M144.601 74.014a10.663 10.663 0 01-2.675-20.977 10.66 10.66 0 112.675 20.977zm-2.058-18.6a8.143 8.143 0 106.235.835 8.2 8.2 0 00-6.235-.831z"
            fill="#7d97f4"
          />
          <path
            data-name="Path 10744"
            d="M98.261 151.155a1.266 1.266 0 01-1.023-.519l-2.229-3.023a19.288 19.288 0 01-5.276-.477l-2.732 2.579a1.272 1.272 0 01-1.464.2l-4.523-2.36a1.272 1.272 0 01-.669-1.314l.564-3.719a19.5 19.5 0 01-3.4-4.064l-3.755-.108a1.275 1.275 0 01-1.176-.9l-1.524-4.892a1.272 1.272 0 01.459-1.4l3.026-2.229a19.282 19.282 0 01.477-5.276l-2.582-2.735a1.275 1.275 0 01-.2-1.458l2.372-4.529a1.275 1.275 0 011.317-.666l3.716.564a19.494 19.494 0 014.061-3.4l.111-3.755a1.275 1.275 0 01.9-1.176l4.88-1.524a1.269 1.269 0 011.4.459l2.229 3.023a19.529 19.529 0 015.276.477l2.732-2.579a1.278 1.278 0 011.461-.2l4.526 2.37a1.269 1.269 0 01.666 1.317l-.561 3.716a19.5 19.5 0 013.4 4.064l3.755.111a1.269 1.269 0 011.176.9l1.524 4.877a1.272 1.272 0 01-.459 1.4l-3.041 2.229a19.25 19.25 0 01-.477 5.273l2.579 2.735a1.275 1.275 0 01.2 1.461l-2.372 4.526a1.263 1.263 0 01-1.314.666l-3.719-.546a19.423 19.423 0 01-4.064 3.4l-.108 3.755a1.266 1.266 0 01-.9 1.173l-4.88 1.524a1.2 1.2 0 01-.359.05zm-.171-1.815zm-2.2-3.632l2.585 3.509 4.1-1.287.129-4.355.438-.258a17.716 17.716 0 004.385-3.662l.33-.387 4.316.654 1.992-3.8-3-3.173.129-.492a17.58 17.58 0 00.513-5.7l-.036-.507 3.509-2.585-1.284-4.1-4.355-.126-.258-.438a17.66 17.66 0 00-3.659-4.376l-.384-.33.651-4.313-3.8-1.992-3.173 3-.492-.126a17.579 17.579 0 00-5.7-.513l-.507.036-2.582-3.509-4.1 1.281-.126 4.358-.438.258a17.585 17.585 0 00-4.388 3.653l-.33.384-4.313-.654-1.98 3.806 3 3.173-.126.492a17.578 17.578 0 00-.513 5.7l.036.507-3.509 2.582 1.284 4.1 4.355.126.258.438a17.605 17.605 0 003.662 4.385l.384.333-.651 4.31 3.8 1.995 3.173-3 .492.129a17.661 17.661 0 005.672.525zm-9.514 2.57zm-4.494-2.369zm32.576-9.5zm-.562-17.224zm-38.232-3.09zm30.692-5.93zm-20.695-2.423zm-.918-.027zm5.4-.969zm3.941 34.642a13.251 13.251 0 01-1.2-26.445.921.921 0 11.165 1.833 11.63 11.63 0 00-2.382.474 11.4 11.4 0 1011.011 2.378.921.921 0 011.224-1.374 13.248 13.248 0 01-8.815 23.134z"
            fill="#7d97f4"
          />
          <path
            data-name="Path 10745"
            d="M1839.281 837.57a37.245 37.245 0 00-9.415 18.638c-2.34 11.928-7.891-16.862-7.891-16.862h-5.615s-2.118 29.664 13.731 32.021a8.5 8.5 0 007.939-3.143c2.894-3.674 7.408-10.2 8.5-16.442-.935-9.824-7.249-14.212-7.249-14.212z"
            transform="translate(-1271.507 -586.366)"
            fill="url(#prefix__bU)"
          />
          <path
            data-name="Path 10746"
            d="M1985.644 1276.334a.9.9 0 00-.027-.267c-1.326-5.261-6.755-7.957-6.755-7.957l-2.609.2c-1.5 4.637-2.469 6.9-2.229 8.17a.426.426 0 00.027.1 61.989 61.989 0 0011.593-.246z"
            transform="translate(-1381.923 -887.772)"
            fill="url(#prefix__bV)"
          />
          <path
            data-name="Path 10747"
            d="M1974.2 1295.782a1.134 1.134 0 00.828.837c3.065.645 7.933.126 9.979-.141a.951.951 0 00.786-.948 62 62 0 01-11.593.252z"
            transform="translate(-1382.071 -906.968)"
            fill="url(#prefix__bW)"
          />
          <path
            data-name="Path 10748"
            d="M1986.664 1254.56l-1.143 5.5a.9.9 0 01-.768.738 7.57 7.57 0 01-1.773-.027 1.131 1.131 0 01-.9-1.329l.792-4.886z"
            transform="translate(-1387.573 -878.286)"
            fill="url(#prefix__bX)"
          />
          <path
            data-name="Path 10749"
            d="M1873.431 1294.561a15.152 15.152 0 004.979-.711v.852a.552.552 0 01-.528.558l-15.3-.1a.7.7 0 01-.561-1.02c1.989.169 7.1.541 11.41.421z"
            transform="translate(-1303.485 -905.792)"
            fill="url(#prefix__bY)"
          />
          <path
            data-name="Path 10750"
            d="M1862.14 1277.321a.6.6 0 01.06-.114c1.353-1.89 4.8-5.651 11.6-7.282l3.266-.1a15.692 15.692 0 011.482 7.2 15.242 15.242 0 01-4.979.711 113.353 113.353 0 01-11.429-.415z"
            transform="translate(-1303.621 -888.97)"
            fill="url(#prefix__bZ)"
          />
          <path
            data-name="Path 10751"
            d="M1904.041 1251.482c-.039.243-.486 3.941-.657 5.375a.708.708 0 01-.6.642 7.482 7.482 0 01-2.244-.036.966.966 0 01-.732-.969v-5.8z"
            transform="translate(-1329.992 -875.577)"
            fill="url(#prefix__ca)"
          />
          <path
            data-name="Path 10752"
            d="M1925.062 1013.65s5.222 46.43 2.322 75.448a22.523 22.523 0 01-5.225-.579s-5.426-45.4-7.2-58.388a.435.435 0 00-.861-.027c-2.165 10.93-10.675 53.787-11.7 57.833 0 0-2.9 1.161-5.222 0 0 0 4.643-62.086 8.125-73.127z"
            transform="translate(-1328.151 -709.634)"
            fill="url(#prefix__cb)"
          />
          <path
            data-name="Path 10753"
            d="M1932.885 830.774s-22.054-3.482-39.465 1.161l1.161 18s4.643 24.958 8.125 35.992c0 0 13.347 2.321 19.733-1.161 0 0 5.222-31.34 8.125-35.992-.009-.01 2.891-12.196 2.321-18z"
            transform="translate(-1325.519 -580.731)"
            fill="url(#prefix__cc)"
          />
          <path
            data-name="Path 10754"
            d="M1954.5 770.54l2.351 17.942s-6.136 2.819-10.435-.123l.924-10.5z"
            transform="translate(-1362.623 -539.441)"
            fill="url(#prefix__cd)"
          />
          <path
            data-name="Path 10755"
            d="M2010.775 833.7s34.24 37.144-6.095 51.361v-2.9s15.09-12.768 3.482-30.179c-.009-.001 1.438-16.542 2.613-18.282z"
            transform="translate(-1403.409 -583.657)"
            fill="url(#prefix__ce)"
          />
          <path
            data-name="Path 10756"
            d="M1980.655 990.268s-5.222-3.482-7.543-2.321-2.322 2.9-2.322 2.9 1.161 2.322 2.9 1.743 5.8.579 7.546 0c.001.01.58-2.322-.581-2.322z"
            transform="translate(-1379.684 -691.474)"
            fill="url(#prefix__cf)"
          />
          <path
            data-name="Path 10757"
            d="M1812.146 780.858l7.367 2.48a2.45 2.45 0 011.581 2.316l-.384 12.3c.12 1.926-1.467 3.62-2.966 3.17l-5.909-2.013a1.516 1.516 0 01-.963-1.524l-.132-15.3c-.006-.898.726-1.636 1.406-1.429z"
            transform="translate(-1267.638 -546.64)"
            fill="url(#prefix__cg)"
          />
          <path
            data-name="Path 10758"
            d="M1807.32 806.67s-2.3-7.39-1.134-8.635 3.509-4.676 3.665-1.872 1.566 14.928-2.531 10.507z"
            transform="translate(-1264.218 -556.627)"
            fill="url(#prefix__ch)"
          />
          <path
            data-name="Path 10759"
            d="M1928.349 755.908c-.033.213 2.585 14.244 2.585 14.244l7.981-1.665-.507-13.671s-9.483-2.477-10.059 1.092z"
            transform="translate(-1349.972 -527.847)"
            fill="url(#prefix__ci)"
          />
          <path
            data-name="Path 10760"
            d="M1927.957 745.99a1.182 1.182 0 01.558.87l.816 7.07a1.047 1.047 0 010 .321c-.1.6-.561 2.433-2.453 1.863a10.559 10.559 0 00-4.2-.717 1.17 1.17 0 00-.936 1.377 43.866 43.866 0 001.637 6.239 1.167 1.167 0 001.41.72 32.453 32.453 0 006.823-2.66 1.176 1.176 0 00.6-1.05c-.048-1.9-.159-7.231.042-8.743.183-1.4 1.88-2.232 2.7-2.549a1.169 1.169 0 00.666-.669 2.578 2.578 0 00-1.623-3.7 1.173 1.173 0 01-.684-1.482 2.589 2.589 0 00-1.452-3.518 3.682 3.682 0 00-4.316.876 1.224 1.224 0 01-1.446.216.771.771 0 00-.768 0 1.14 1.14 0 01-1.544-.5 3 3 0 00-3.422-1.7c-3.572.552-4.04 4.5-3.14 6.82s4.742 1.5 6.68.378c1.395-.852 3.195.019 4.052.538z"
            transform="translate(-1341.907 -516.795)"
            fill="url(#prefix__cj)"
          />
          <path
            data-name="Path 10761"
            d="M1967.071 777.365s-1.011-3.9.51-4.865 3.743-.42 3.2 2.543c-.662 3.687-3.71 2.322-3.71 2.322z"
            transform="translate(-1376.85 -540.507)"
            fill="url(#prefix__ck)"
          />
          <path
            data-name="Path 10762"
            d="M574.622 225.908a.126.126 0 01-.114-.072c-1.3-2.777 1.73-4.994 1.76-5.018a.126.126 0 01.144.2c-.027.021-2.888 2.121-1.679 4.709a.123.123 0 01-.06.165.114.114 0 01-.051.016z"
            fill="#fff"
          />
          <path
            data-name="Path 10763"
            d="M526.719 234.615v25.368c0 2.067-1.26 3.743-2.813 3.743H431.49c-1.29 0-2.4 1.17-2.729 2.834l-1.656 8.833c-.219 1.17-1.443 1.269-1.767.141l-2.133-7.462a2.957 2.957 0 00-2.63-2.4h-3.968c-1.554 0-2.813-1.677-2.813-3.743v-26.087c0-2.055 1.245-3.725 2.789-3.743l107.307-1.227c1.555-.018 2.829 1.664 2.829 3.743z"
            fill="#bdd0fb"
          />
          <ellipse
            data-name="Ellipse 478"
            cx={11.335}
            cy={11.634}
            rx={11.335}
            ry={11.634}
            transform="translate(416.752 235.823)"
            fill="#7d97f4"
          />
          <path
            data-name="Path 10764"
            d="M1423.337 801.022c0 2.1-1.695 4.346-3.785 4.346s-3.782-2.255-3.782-4.346a3.79 3.79 0 017.567 0z"
            transform="translate(-991.133 -558.279)"
            fill="url(#prefix__cl)"
          />
          <path
            data-name="Path 10765"
            d="M1406.573 834.715h9.238a2.237 2.237 0 002.129-1.557l.495-1.554a2.228 2.228 0 00-1.35-2.777 17.217 17.217 0 00-11.628.126 2.229 2.229 0 00-1.425 2.7l.381 1.41a2.241 2.241 0 002.16 1.652z"
            transform="translate(-982.859 -579.579)"
            fill="url(#prefix__cm)"
          />
          <path
            data-name="Path 10766"
            d="M1558.555 830.067a2.249 2.249 0 01-2.292 2.2h-67.452a2.25 2.25 0 01-2.291-2.2 2.246 2.246 0 012.291-2.2h67.452a2.246 2.246 0 012.292 2.2z"
            transform="translate(-1040.663 -579.574)"
            fill="url(#prefix__cn)"
          />
          <path
            data-name="Path 10767"
            d="M1528.337 854.05a2 2 0 01-2 2h-35.362a2 2 0 01-2-2 2 2 0 012-2h35.362a2 2 0 012 2z"
            transform="translate(-1042.385 -596.503)"
            fill="url(#prefix__co)"
          />
          <path
            data-name="Path 10768"
            d="M1657.929 854.05a2 2 0 01-2 2h-25.521a2 2 0 01-2-2 2 2 0 012-2h25.521a2 2 0 012 2z"
            transform="translate(-1139.995 -596.503)"
            fill="url(#prefix__co)"
          />
          <rect
            data-name="Rectangle 1502"
            width={39.666}
            height={5.843}
            rx={2.921}
            transform="translate(445.671 236.789)"
            fill="#7d97f4"
          />
          <path
            data-name="Path 10769"
            d="M510.623 810.341c-.021 22.3-.192 99.221-1.527 126.452-.141 2.882-2.172 5.156-4.64 5.2-12.213.195-56.988.39-76.915-1.032-4.154-.3-7.372-4.31-7.351-9.178.1-23.395.645-89.23 3.488-119.329.339-3.6 2.825-6.428 5.918-6.721 13.323-1.26 58.337-4.067 75.553-2.378 3.104.303 5.477 3.339 5.474 6.986z"
            transform="translate(-294.161 -562.043)"
            fill="url(#prefix__cp)"
          />
          <path
            data-name="Path 10770"
            d="M519.7 835.7c.258 18 1 77.908-.144 100.025-.168 3.233-2.4 5.8-5.171 5.93-11.4.525-50.23 1.383-66.885-.549-3-.348-5.291-3.242-5.375-6.767-.408-18.374-1.608-74.159-.5-96.021.177-3.488 2.552-6.3 5.534-6.536 12.333-1.02 53.631-3.182 67.785-1.962 2.656.221 4.725 2.764 4.756 5.88z"
            transform="translate(-308.849 -580.688)"
            fill="url(#prefix__cq)"
          />
          <path
            data-name="Path 10771"
            d="M566.444 813.39a1.218 1.218 0 01-1.068 1.263c-2.888.111-11.017.432-14.652.6a1.226 1.226 0 01-1.107-1.551l.024-.141a1.176 1.176 0 011-1.014 120.117 120.117 0 0114.775-.462 1.205 1.205 0 011.028 1.305z"
            transform="translate(-384.751 -568.461)"
            fill="url(#prefix__cr)"
          />
          <circle
            data-name="Ellipse 479"
            cx={28.614}
            cy={28.614}
            r={28.614}
            transform="translate(143.218 276.614)"
            fill="url(#prefix__cs)"
          />
          <path
            data-name="Path 10772"
            d="M548.977 990.221a5.1 5.1 0 00-3.026-3.353l-2.058-.816a3.947 3.947 0 00-4.616 1.3l-1.833 2.447a14.983 14.983 0 01-9.148-3.194 15.258 15.258 0 01-5.5-7.363.09.09 0 01.141-.1l1.65-2.208a4.5 4.5 0 00-.078-5.5l-1.368-1.719a5.159 5.159 0 00-8.17.12 6.688 6.688 0 00-1.083 2.216c-1.518 5.363 2.8 13.467 10.768 19.433s16.949 7.807 21.667 4.844a6.668 6.668 0 001.83-1.671 5.1 5.1 0 00.824-4.436z"
            transform="translate(-359.545 -677.516)"
            fill="url(#prefix__ct)"
          />
          <path
            data-name="Path 10773"
            d="M438.8 1194.186a8.8 8.8 0 01-8.8-8.746v-14.928a.307.307 0 11.615 0v14.928a8.173 8.173 0 008.176 8.1.324.324 0 01.324.318.3.3 0 01-.312.33z"
            transform="translate(-301.029 -819.232)"
            fill="url(#prefix__cu)"
          />
          <path
            data-name="Path 10774"
            d="M297 1258.36s-.6 3.35-.882 6.667a2.286 2.286 0 002.186 2.475c4.418.186 13.866.543 17.258.393a.747.747 0 00.654-1.02 1.673 1.673 0 00-.852-.9l-15.6-7.174z"
            transform="translate(-207.3 -880.947)"
            fill="url(#prefix__cv)"
          />
          <path
            data-name="Path 10775"
            d="M297.47 1250.348l.474 4.01s2.735 1.272 4.6-.162l-1.131-4.466z"
            transform="translate(-208.25 -874.905)"
            fill="url(#prefix__cw)"
          />
          <path
            data-name="Path 10776"
            d="M269.728 1000.535c-.207 1.047-1.1 52.23 4.367 75.166a.777.777 0 01-.456.9 13.5 13.5 0 01-4.454.9 1.341 1.341 0 01-1.332-.963c-1.563-5.321-9.058-31.985-10.036-57.455-1.092-28.464 0-.969 0-.969l.642-17.594z"
            transform="translate(-180.15 -700.442)"
            fill="url(#prefix__cx)"
          />
          <path
            data-name="Path 10777"
            d="M234.829 1264.19a24.172 24.172 0 00-1.857 6.185 1.395 1.395 0 001.227 1.671 53.453 53.453 0 005.5.3 1.392 1.392 0 001.377-1.551 11.73 11.73 0 00-2.738-6.431z"
            transform="translate(-163.077 -885.028)"
            fill="url(#prefix__cy)"
          />
          <path
            data-name="Path 10778"
            d="M236.47 1246.447l1.11 6.062a3.925 3.925 0 003.272.225l-.531-6.523z"
            transform="translate(-165.546 -872.441)"
            fill="url(#prefix__cz)"
          />
          <path
            data-name="Path 10779"
            d="M222.439 999.191c-4.475 26.994.972 66.747 2.807 74.525a1.2 1.2 0 00.978.921 8.094 8.094 0 003.5-.138 1.116 1.116 0 00.8-1.026c.246-6.3-.2-44.891 3.971-60.149a3.476 3.476 0 011.338-1.913l8.1-5.753.621-9.3z"
            transform="translate(-154.517 -697.529)"
            fill="url(#prefix__cA)"
          />
          <path
            data-name="Path 10780"
            d="M251.1 830.069c-13.41-.222-28.194 3.521-28.194 3.521-4 23.323-.7 50.227-.7 50.227 10.381 2.72 22.093-1.665 22.093-1.665 1.725-9.751 9.775-37.192 9.775-37.192a44.078 44.078 0 0016.4-5.2 28.7 28.7 0 01-5.684-11.886 44.979 44.979 0 01-13.69 2.195z"
            transform="translate(-154.666 -579.576)"
            fill="url(#prefix__cB)"
          />
          <path
            data-name="Path 10781"
            d="M393.055 766.971a2.567 2.567 0 00-2.984-.837c-1.974 8.335-12.321 15.1-22.951 18.4a28.7 28.7 0 005.684 11.886c17.639-9.92 20.251-29.449 20.251-29.449z"
            transform="translate(-257.009 -536.231)"
            fill="url(#prefix__cC)"
          />
          <path
            data-name="Path 10782"
            d="M446.3 737.262c.138.438-1.458 1.107-2.4-.687-.033-.858-.555-4.538-.042-5.237a68.339 68.339 0 018.032-8.4 1.26 1.26 0 01.159 1.752l-2.573 2.678a12.242 12.242 0 011.5 2.966 3.6 3.6 0 01-.36 2.651 31.342 31.342 0 01-1.65 2.7 3.558 3.558 0 01-2.666 1.575z"
            transform="translate(-310.572 -506.118)"
            fill="url(#prefix__cD)"
          />
          <path
            data-name="Path 10783"
            d="M452.19 743.5l-2.345 1.986-.735 1.979 2.1 2.316a26.937 26.937 0 011.224-4.772c.521-.849.242-1.26-.244-1.509z"
            transform="translate(-314.408 -520.511)"
            fill="url(#prefix__cE)"
          />
          <path
            data-name="Path 10784"
            d="M198.58 859.924l-5.144-12.984s-12.525 8.509-14.586 19.3a28.493 28.493 0 0110.543 2.957c1.907-4.279 9.187-9.273 9.187-9.273z"
            transform="translate(-125.208 -592.926)"
            fill="url(#prefix__cF)"
          />
          <path
            data-name="Path 10785"
            d="M266.215 798.858l-4.271 12.327a.45.45 0 00.2.537 10.028 10.028 0 0010.4-.7 2.1 2.1 0 00.966-1.5l1.38-10.681z"
            transform="translate(-183.362 -559.253)"
            fill="url(#prefix__cG)"
          />
          <path
            data-name="Path 10786"
            d="M281.666 760.8s4.685 8.821 4.085 12.384-6.407 3.3-11.478.414l-3.542-9.523z"
            transform="translate(-189.53 -532.622)"
            fill="url(#prefix__cH)"
          />
          <path
            data-name="Path 10787"
            d="M259.452 753.965a.363.363 0 00.159-.531 9.493 9.493 0 01-1.3-2.768s-.843-.54 2.145-1.254 7.438-1.824 8.374-4.367c.9-2.477-1.5-8.7-5.309-3.743a.363.363 0 01-.576 0c-.63-.816-2.276-2.51-4.565-1.482a3.433 3.433 0 00-2.354 3.32.363.363 0 01-.429.372 4.191 4.191 0 00-4.895 2.282c-1 2.2-.351 3.437.243 4.046a.363.363 0 01-.156.6 2.177 2.177 0 00-1.539 2.487c.126 2.307 2.7 2.1 3.437 2a.363.363 0 01.324.114c.63.7 3.464 3.653 6.533 4.01a.369.369 0 00.384-.486l-1.329-3.857a.366.366 0 01.2-.453z"
            transform="translate(-174.484 -517.668)"
            fill="url(#prefix__cI)"
          />
          <path
            data-name="Path 10788"
            d="M276.681 787.056s-3.338-2.289-3.581-.36 3 2.789 4.613 2.073z"
            transform="translate(-191.18 -550.21)"
            fill="url(#prefix__cJ)"
          />
          <path
            data-name="Path 10789"
            d="M175.094 910.193s-8.56 19.5 12.366 22.354l2.852-2.379s-10.462-5.708-4.763-17.123c.001 0-6.175-5.231-10.455-2.852z"
            transform="translate(-121.365 -636.773)"
            fill="url(#prefix__cK)"
          />
          <path
            data-name="Path 10790"
            d="M225.974 945.78l7.369 2.483a2.44 2.44 0 011.578 2.316l-.384 12.3c.12 1.926-1.467 3.62-2.966 3.17l-5.909-2.012a1.52 1.52 0 01-.963-1.524l-.129-15.3c-.009-.899.73-1.637 1.404-1.433z"
            transform="translate(-157.215 -662.097)"
            fill="url(#prefix__cL)"
          />
          <path
            data-name="Path 10791"
            d="M219.909 969.067a9.994 9.994 0 01-1.224-6.113c.354-3.371-.3-4.895 1.269-4.763s2.873.4 2.7 2.055.314 12.201-2.745 8.821z"
            transform="translate(-153.054 -670.804)"
            fill="url(#prefix__cM)"
          />
        </g>
      </g>
    </svg>
  )
}

export default SvgComponent
